<template>
    <div class="score">
        <AdModal ref="adModal" v-show="isAdModalVisible" @submitScoreCard="doSubmitScoreCard" @close="closeAdModal" :playProp="isAdModalVisible"/>
        <!--<MoodModal ref="moodModal" v-show="isMoodModalVisible" @submitMood="submitMood" @close="closeMoodModal" :playProp="isMoodModalVisible"/>-->
        <div class="hero is-primary">
            <div class="hero-body">
                <div class="container">
                    <div v-if="!$auth.isAuthenticated">
                        <h1 class="title is-size-1">Scorecard</h1> 
                    </div>
                    <div v-if="$auth.isAuthenticated">
                        <h3 class="title is-size-3">Scorecard</h3> 
                    </div>
                    <div>
                        <div v-if="!isSubscribed">
                            <div v-if="!subscriptionChecked">
                                <P class="blink is-text-4">Please wait, checking for subscription...</p>
                            </div>
                        </div>
                        <div v-if="isSubscribed">
                            <P class="is-italic is-size-7 has-text-grey">Valid subscrpition found.  Thanks for your membership.</p>
                        </div>
                    </div>
               </div>
            </div>
        </div>
        <div class="container">

            <div v-if="!isSubscribed">
                <div v-if="subscriptionChecked">
                    <br/>
                    <P class="is-italic is-size-3">No subscription found.  To score your throws and make the rankings, you must purchase a <a href="/subscribe">subscription</a>.</p>
                    <br/>
                </div>
            </div>
            <div v-if="isSubscribed">

                <div v-if="weather !=  null && weather.weather != null && weather.main != null" class="weather_container">
                    <div class="weather_container_inner">
                        <table>
                            <tr>
                                <td style="padding-top: 10px; width: 80%;">
                                    <b>
                                        <span v-if="weather != null && weather.name != null">
                                            {{ weather.name }} 
                                        </span>
                                        <span v-if="weather != null && weather.sys != null && weather.sys.country != null">
                                            {{ weather.sys.country }}
                                        </span>
                                    </b>
                                    <span v-if="weather != null && weather.main != null && weather.main.temp != null">
                                        {{ (Math.round(weather.main.temp)) }}c
                                    </span>
                                </td>
                                <td rowspan="2">
                                    <span v-if="weather != null && weather.weather != null">
                                        <img v-bind:src="'http://openweathermap.org/img/w/' + weather.weather[0].icon + '.png'" /> 
                                    </span>
                                </td>
                                <td rowspan="2">
                                    <span class="is-size-5 is-pulled-right"><a @click="removeWeather" style="color: red;" title="Remove Weather"><i class="fas fa-times-circle"></i></a></span>
                                </td>
                            </tr>
                            <tr>
                                <td style="font-style: italic;">
                                    <p class="weather_container_subtitle">
                                        <span v-if="weather != null && weather.weather != null">
                                            {{ weather.weather[0].description }}, 
                                        </span>
                                        <span v-if="weather != null && weather.wind != null && weather.wind.speed != null">
                                            wind {{ Math.round(weather.wind.speed) }}km/h
                                        </span>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div v-if="!isStarted">
                    <div class="gamesetup">
                        <div class="columns">
                            <div class="column">
                                <h1 class="title is-size-3">Setup</h1>

                                <div v-if="this.savedGamesInProgress.length > 0" style="border: solid goldenrod 1px; border-radius: 10px; padding: 10px;">
                                    <h1 class="title is-size-4">Saved Games</h1>
                                    <p>To resume a saved game, click a link below. You can also delete the entry.</p>
                                    <br/>
                                    <div v-for="(gm, idx) in this.savedGamesInProgress" :key="gm.Guid" class="columns is-mobile">
                                        <div class="column is-one-fifth">
                                            <i class="fas fa-bullseye has-text-warning"></i>
                                        </div>
                                        <div class="column is-four-fifths">
                                            {{  gm.gameType  }} <b>{{ gm.title }}</b>
                                            <br/>
                                            {{  gm.dateTimeStamp | formatDateTime }} 
                                            <br/>
                                            <a v-on:click="resumeGameFromLocalStorage(gm)">
                                                <i class="fas fa-box-open has-text-success" title="Resume Game"></i>
                                                <span class="has-text-success">resume</span>
                                            </a>
                                            &nbsp;
                                            <a v-on:click="deleteGameFromLocalStorage(gm)">
                                                <i class="fas fa-trash has-text-danger" title="Delete Game"></i>
                                                <span class="has-text-danger">delete</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <h1 class="title is-size-4">Game Type</h1>
                                <div class="columns">
                                    <div class="column">
                                        <p class="is-size-4">
                                            <input type="radio" class="radio-gameType" v-model="gameData.gameType" value="Solo" selected id="solo"> <label for="solo">Solo</label>
                                        </p>
                                    </div>
                                    <div class="column">
                                        <p class="is-size-4">
                                            <input type="radio" class="radio-gameType" v-model="gameData.gameType" value="Round-Robin" id="roundrobin"> <label for="roundrobin">Round-Robin</label> 
                                        </p>
                                    </div>
                                    <div class="column" v-show="this.isAdmin()">
                                        <p class="is-size-4">
                                            <input type="radio" class="radio-gameType" v-model="gameData.gameType" value="Tournament" id="tournament"> <label for="tournament">Tournament</label>
                                        </p>
                                    </div>
                                    <div class="column" v-show="this.isAdmin()">
                                        <p class="is-size-4">
                                            <input type="radio" class="radio-gameType" v-model="gameData.gameType" value="Challenge" id="challenge" disabled> <label for="challenge">Challenge</label>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="gameData.gameType == GameType.ROUNDROBIN || gameData.gameType ==  GameType.TOURNAMENT">

                            <!-- import player functionality -->
                            <!--
                            <div v-show="this.isAdmin() && gameData.gameType == GameType.ROUNDROBIN">
                                <button class="button is-success" v-show="!showBookingFeature" 
                                    @click="showBookingFeature = true" title="Import Bookings">
                                    <span><i class="fas fa-chevron-right"></i> SHOW BOOKINGS</span>
                                </button>
                            </div>
                            -->
                            <div v-show="showBookingFeature && this.isAdmin() && gameData.gameType == GameType.ROUNDROBIN" style="background-color: green; padding: 20px; border-radius: 25px;">
                                <h1 class="is-size-3">Import Booking Data:</h1>

                                <div class="columns">
                                    <div class="column">
                                        <p class="is-size-5">Location:</p>
                                        <div class="select is-rounded is-medium">
                                            <select  v-model="locationPicked">
                                                <option>...</option>
                                                <option>Dartmouth</option>
                                                <option>Moncton</option>
                                                <option>Barrington</option>
                                            </select>                                
                                        </div>
                                    </div>
                                    <div class="column">
                                        <p class="is-size-5">Lane:</p>
                                        <div class="select is-rounded is-medium">
                                            <select v-model="lanePicked">
                                                <option>...</option>
                                                <option value="1">Lane 1</option>
                                                <option v-if="locationPicked === 'Moncton' || locationPicked === 'Dartmouth'" value="2">Lane 2</option>
                                                <option v-if="locationPicked === 'Moncton'" value="3">Lane 3</option>
                                            </select>                                
                                        </div>
                                    </div>
                                    <div class="column">
                                        <button class="button is-medium is-warning" @click="getBookingsForToday()">Get Bookings</button>
                                    </div>
                                </div>
                                <div>
                                    <div v-for="(throw_day, index) in booking_data" :key="index">
                                        <div v-for="lane in throw_day.bookings.lanes" :key="lane.id">
                                            <div v-if="lane.id == lanePicked">
                                                <div v-for="team in lane.teams" :key="team.id">
                                                    <div v-if="team.team != ''" class="box" style="margin-bottom: 6px;">
                                                        <div class="columns has-text-white">
                                                            <div class="column">
                                                                <span class="is-size-3">{{ team.time_slot }}</span>
                                                            </div>  
                                                            <div class="column">
                                                                <span class="is-size-3">{{ team.team }}</span>
                                                            </div>  
                                                            <div class="column is-2">
                                                                <span>
                                                                    <button class="button is-warning" @click="setTeam(lane.id, team.id, team.team, team.timeslot_guid, team.time_slot)">Select Team</button>
                                                                </span>
                                                            </div>  
                                                        </div>
                                                        <div class="columns" v-if="team.players == null || team.players.length === 0">
                                                            <div clas="column">
                                                                <div>
                                                                    <button class="button is-primary" @click="getSigninsByTeam(team.timeslot_guid)"><i class="fas fa-table"></i>Show Players</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="columns" v-if="team.players != null && team.players.length != 0">
                                                            <div class="column">
                                                                <div v-for="player in team.players" :key="player._id">
                                                                    <div class="columns is-mobile">
                                                                        <div class="column is-3">
                                                                            <figure class="image image is-64x64">
                                                                                <img class="is-rounded" :src="player.user.picture">
                                                                            </figure>
                                                                        </div>
                                                                        <div class="column is-8 has-text-centered" style="color: white;">
                                                                            <span class="is-size-6 has-text-weight-bold">
                                                                                {{ userNameDisplay(player) }}<br/>
                                                                            </span>
                                                                            <span class="is-size-7">
                                                                                {{ signInDateDisplay(player.datetimestamp) }}
                                                                            </span>
                                                                        </div>
                                                                        <div class="column is-1">
                                                                            <button class="button is-danger" @click="removePlayerSignin(team,player)"><i class="fas fa-trash"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <h1 class="title is-size-3">Title <span class="required_title"><sup>*</sup>required</span> </h1>
                                    <input class="input" style="width: 90%;" type="text" v-model="gameData.title" placeholder="Title"/> 
                                </div>
                                <div class="column">
                                    <h1 class="title is-size-3">League</h1>
                                    <div class="select is-rounded">
                                        <!-- this-->
                                        <select v-model="league">
                                            <option selected>Open</option>
                                            <option>Mens</option>
                                            <option>Womens</option>
                                            <option>Youth</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- restrict this to admin only -->
                                <div class="column" v-show="this.isAdmin() && this.gameData.gameType === GameType.ROUNDROBIN">
                                    <h1 class="title is-size-3">Location</h1>
                                    <div class="select is-rounded">
                                        <!-- this-->
                                        <select v-model="gameData.lane_id">
                                            <option selected></option>
                                            <option>Dartmouth Lane 1</option>
                                            <option>Dartmouth Lane 2</option>
                                            <option>Moncton Lane 1</option>
                                            <option>Moncton Lane 2</option>
                                            <option>Moncton Lane 3</option>
                                            <option>Testing Lane 1</option>
                                            <option>Testing Lane 2</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="gameData.gameType == GameType.ROUNDROBIN || gameData.gameType ==  GameType.TOURNAMENT">

                            <div class="columns" v-if="!isStarted">
                                <div class="column">
                                    <h1 class="title is-size-3">Players</h1>

                                    <!-- upload sign-in sheet -->
                                    <div v-show="this.isSuper() && gameData.gameType == GameType.ROUNDROBIN" class="signatureFormUpload">
                                        <p>Upload a sign-in sheet:</p>
                                        <form @submit.prevent="submitForm">
                                            <input 
                                                type="file" 
                                                accept="image/*"
                                                capture="environment"
                                                @change="handleFileUpload"
                                                ref="fileInput"
                                            />
                                            <button type="submit">Upload</button>
                                        </form>
                                        <div v-show="pleaseWait" style="position: absolute;">
                                            <img :src="`${publicPath}img/pleasewait.gif`" style=" width: 25%;"/>
                                        </div>
                                    </div>

                                    <div>
                                        <div style="margin-top: 5px;">
                                            <div class="columns">
                                                <div class="column">
                                                </div>
                                                <div class="column">
                                                    Name
                                                </div>
                                            </div>
                                        </div>
                                        <div v-for="(player, index) in gameData.players" :player="player" :key="player.player">
                                            <div style="margin-top: 5px;">
                                                <div class="columns is-mobile">
                                                    <div class="column is-2 is-size-7">
                                                        <span class="is-size-7">
                                                            {{ (index+1) }}&nbsp;
                                                        </span>
                                                        <span class="populateUser is-size-7" v-on:click="populateUser(index)">
                                                            <i class="fas fa-user is-size-7" style="font-size: 1.5em; padding-top: 6px;"></i>
                                                        </span>
                                                    </div>
                                                    <div class="column">
                                                        <div>
                                                            <input class="input" style="width: 95%;" type="text" v-model="player.name" placeholder="Name"/> 
                                                            <div v-show="player.emailVisible">
                                                                <input class="input" style="width: 95%; margin-top: 6px;" type="text" v-model="player.email" placeholder="Email"/> 
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="column is-2">
                                                        <div>
                                                            <span v-on:click="toggleEmailVisibility(player)">
                                                                <span v-show="player.emailVisible">
                                                                    <i class="fas fa-chevron-up"></i>
                                                                </span>
                                                                <span v-show="!player.emailVisible">
                                                                    <i class="fas fa-chevron-down"></i>
                                                                </span> 
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="margin: 20px;" v-if="gameData.gameType ==  GameType.TOURNAMENT">
                                        <a class = "button is-info" v-on:click="addPlayers(10);">Add 10 more players...</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <ThrowSettings  
                                        :gameData="gameData" 
                                        :sets="sets"
                                        :rounds="rounds"
                                        :throws="throws"
                                        :targets="targets"/>
                            </div>
                        </div>

                        <div v-show="this.isAdmin() && (this.gameData.gameType ===  GameType.TOURNAMENT || this.gameData.gameType === GameType.ROUNDROBIN)">
                            <div>
                                <label class="checkbox" id="checkbox">
                                    <input type="checkbox" v-model="liveLoggingEnabled">&nbsp;
                                    <span class="is-size-5">Enable Live Scores</span>
                                </label>
                                <p><a href="https://axes2.ca/display" target="new">http://axes2.ca/display</a></p> 
                            </div>
                        </div>
                        
                        <div class="columns">
                            <div class="column">
                                <div class="box">
                                    <div class="score-button">
                                        <a class="button is-link" v-on:click="buildGame">Start!</a>
                                    </div>
                                    <div class="score-button">
                                        <a class="button is-danger" v-on:click="resetScoreCard">Reset</a>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>

                <div v-if="gameData.gameType === GameType.SOLO">
                    <div class="mood-info-box">
                        <div @click="toggleMoodBox">
                            <p>
                              <span class="mood-heading">Personal Sports Journal</span>
                              <span class="mood-heading-icon">&nbsp;<i class="fa-solid fa-book"></i></span>
                            </p>
                        </div>
                        <div v-if="isMoodBoxOpen" class="mood-content-box">
                            <div class="columns">
                                <div class="column is-3">
                                    <p class="is-size-6">I feel:</p>
                                    <span style="margin: 5px;">
                                        <span>
                                        <i class="fa-solid fa-face-smile emoji-green" @click="setMood('good')"
                                        :style="this.gameData.mood.feel == 'good' ? { 'color':  'green' } : {  }"></i>
                                        </span>
                                        <span>
                                        <i class="fas fa-face-meh emoji-yellow" @click="setMood('neutral')"
                                        :style="this.gameData.mood.feel == 'neutral' ? { 'color':  'yellow' } : {  }"></i>
                                        </span>
                                        <span>
                                        <i class="fas fa-face-frown emoji-red" @click="setMood('bad')"
                                        :style="this.gameData.mood.feel == 'bad' ? { 'color':  'red' } : {  }"></i>
                                        </span>
                                    </span>
                                </div>
                                <div class="column is-3">
                                    <p class="is-size-6">My goal is:</p>
                                    <textarea cols="40" rows="2" v-model="gameData.mood.goalText" style="font-size: 14pt; width: 265px; margin: 5px;"></textarea>
                                </div>
                                <div class="column is-3">
                                    <p class="is-size-6">My focus was:</p>
                                    <textarea cols="40" rows="2" v-model="gameData.mood.focusText" style="font-size: 14pt; width: 265px; margin: 5px;"></textarea>
                                </div>
                                <div class="column is-3">
                                    <p class="is-size-6">Working notes:</p>
                                    <textarea cols="40" rows="2" v-model="gameData.mood.workingNotesText" style="font-size: 14pt; width: 265px; margin: 5px;"></textarea>
                                </div>
                            </div>                        
                        </div>

                    </div>
                </div>

                <div v-if="(gameData.gameType === GameType.ROUNDROBIN || gameData.gameType ===  GameType.TOURNAMENT) && isCoachInfoDisplayed">
                    <div class="info-card">
                        <div style="margin-bottom: 10px;">
                            <div class="is-size-4 is-pulled-right has-text-right btn-close"><a @click="closeCoachInfo"><i class="fas fa-times-circle"></i></a></div>
                            <div class="is-size-4">{{ gameData.title }}</div>
                        </div>
                        <div class="info-card-inner">
                            <div class="is-size-5">{{ gameData.gameType }}</div>
                            <div v-if="gameData.rounds != null">
                                <div v-for="(round) in gameData.rounds" :key="round.uniqueId">
                                    <div v-if="round.type != 'Finals'">
                                        <div class="is-size-6" style="padding-top: 8px;">Round {{ round.id }}</div>
                                        <div v-for="(match) in round.matches" :key="match.uniqueId">
                                            <div class="is-size-6" style="padding-left: 25px; padding-top: 8px;">Match 
                                                {{ match.id | formatId }}
                                            </div>
                                            <div v-for="(matchPlayer) in match.matchPlayers" :key="matchPlayer.id">
                                                <div class="is-size-6" style="padding-left: 50px; padding-top: 8px;">{{ matchPlayer.player.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="gameData.sets != null">
                                <div v-for="(set) in gameData.sets" :key="set.uniqueId">
                                    <div class="is-size-6" style="padding-top: 8px;">Set {{set.id }}</div>
                                    <div v-if="set.rounds != null">
                                        <div v-for="round in set.rounds" :key="round.uniqueId">
                                            <div v-if="round.type != 'Finals'">
                                                <div class="is-size-6" style="padding-left: 25px; padding-top: 8px;">Round {{ round.id }}</div>
                                                <div v-for="match in round.matches" :key="match.uniqueId">
                                                    <div class="is-size-6" style="padding-left: 50px; padding-top: 8px;">Match 
                                                        {{ match.id }}
                                                    </div>
                                                    <div v-for="(matchPlayer) in match.matchPlayers" :key="matchPlayer.id">
                                                        <div class="is-size-6" style="padding-left: 75px; padding-top: 8px;">{{ matchPlayer.player.name }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isStarted && gameData.gameType ===  GameType.TOURNAMENT">

                    <div class="box" style="background-color: black; border: solid goldenrod 1px;">
                        <span class="is-size-4 is-pulled-right has-text-right btn-close">
                            <a @click="showCoachInfo"><i style="color: red;" class="fas fa-tree"></i></a>
                        </span>
                        <div v-if="gameData.title != null">
                            <h1 class="title is-size-2 gameTitle">{{ gameData.title }}
                                <span v-if="gameData.league != null" class="subtitle is-size-5">{{ gameData.league }}</span>
                            </h1>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="box is-paddingless" :key="tournamentKey">
                                <div v-for="set in gameData.sets" :key="set.uniqueId">
                                    <div v-if="set.type != 'Finals'">
                                        <div class="box" style="background-color: gray; border: solid goldenrod 1px;">
                                            <h1 class="set-title is-size-2">Set {{ set.id }}</h1>
                                        </div>
                                        <div class="box is-paddingless" style="margin-bottom: 50px;" v-for="round in set.rounds" :round="round" :key="round.uniqueId">
                                            <div v-if="round.type != 'Finals'">
                                                <Round :round="round" :gameType="gameData.gameType"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="isStarted && (gameData.gameType == GameType.SOLO || gameData.gameType == GameType.ROUNDROBIN)">
                    <span class="is-size-4 is-pulled-right has-text-right btn-close" v-if="gameData.gameType == GameType.ROUNDROBIN">
                        <a @click="showCoachInfo"><i style="color: red;" class="fas fa-tree"></i></a>
                    </span>
                    <div v-if="gameData.title != null">
                        <h1 class="title is-size-2 gameTitle">{{ gameData.title }}
                            <span v-if="gameData.league != null" class="subtitle is-size-5">{{ gameData.league }}</span>
                        </h1>
                    </div>
                    <div class="columns" style="padding-left: 0px; padding-right: 0px; margin-left: 0px; margin-right: 0px;">
                        <div class="column" style="padding-left: 0px; padding-right: 0px;">
                            <div class="box is-paddingless" style="padding-left: 0px; padding-right: 0px;">
                                <div v-for="round in gameData.rounds" :round="round" :key="round.uniqueId">
                                    <div v-if="round.type != 'Finals'">
                                        <Round :round="round" :gameType="gameData.gameType"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="isStarted">
                    <div v-if="hasFinals">
                        <div class="columns">
                            <div class="column">
                                <div class="box game-finals" id="finalsHeading">
                                    <h4 class="is-size-2 finals-heading" id="finals">Finals</h4>
                                </div>
                            </div>
                        </div>

                        <!-- FINALS -->
                        <div class="columns">
                            <div class="column">
                                <div class="box is-paddingless">
                                    <div v-if="gameData.gameType ===  GameType.TOURNAMENT">

                                        <div v-for="st in gameData.sets" :key="st.uniqueId">
                                            <div v-if="st.type === 'Finals'">
                                                <div class="box" style="background-color: goldenrod; margin-top: 60px;">
                                                    <h1 class="set-title is-size-2">FINALS Set {{ st.id }}</h1>
                                                </div>
                                                <div class="box is-paddingless" v-for="round in st.rounds" :round="round" :key="round.uniqueId">
                                                    <Round :round="round" :gameType="gameData.gameType"/>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    </div>
                                    <div v-else>
                                        <div v-for="round in gameData.rounds" :round="round" :key="round.uniqueId">
                                            <div v-if="round.type === 'Finals'">
                                                <Round :round="round" :gameType="gameData.gameType"/>
                                            </div>
                                        </div>
                                        <div v-if="roundsRemaining != null">
                                            <div :key="roundsComponentKey">
                                                <div v-for="(round, index) in roundsRemaining" :key="index">
                                                    <RoundEmpty :round="round"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div v-if="isStarted  && showFinalsPlayerSelection && 
                        ((gameData.gameType == GameType.ROUNDROBIN && !hasFinals) || gameData.gameType ===  GameType.TOURNAMENT)">
                        <div>
                            <br/>
                            <div class="box" style="background-color: goldenrod;">
                                <h1 class="title is-size-2 finals-heading">Finals</h1>
                                <h1 class="title is-size-4 finals-heading">Select Players (sorted by Average):</h1>
                            </div>
                            <div class="box game-finals">

                                <div class="tabs-holder">
                                    <div class="tabs is-small is-toggle">
                                        <ul>
                                            <li :class="{  'is-active' : sortFinalPlayers == 'avg' }">
                                                <a v-on:click="setFinalPlayerSort('avg')">Sort by Avg</a>
                                            </li>
                                            <li :class="{  'is-active' : sortFinalPlayers == 'custom' }">
                                                <a v-on:click="setFinalPlayerSort('custom')">Custom Sort</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <div v-if="sortFinalPlayers == 'avg'">
                                            <div class="columns is-mobile">
                                                <div class="column is-6">Player</div>
                                                <div class="column is-1"><i class="fas fa-award winner"></i></div>
                                                <div class="column is-1"><i class="fas fa-bullseye"></i></div>
                                                <div class="column is-2">Avg</div>
                                                <div class="column is-2">Total</div>
                                            </div>
                                            <div v-for="(player, index) in this.playersSortedByAverage" :player="player" :key="player.player">
                                                <div class="columns is-mobile">
                                                    <div class="column is-6">
                                                        <span style="display: inline; float: left;">
                                                            <label class="checkbox">
                                                                <input class="custom_checkbox" type="checkbox" v-bind:id="player.id" v-model="player.selectedForFinals">
                                                            </label>
                                                        </span>
                                                        <span style="display: inline; float: left;">
                                                            &nbsp;{{ (index+1) }}
                                                        </span>
                                                        <span style="display: inline; float: left;">
                                                            <label  v-bind:for="player.id">
                                                                &nbsp;{{ player.given_name || player.name}} 
                                                            </label>
                                                        </span>
                                                    </div>
                                                    <div class="column is-1">
                                                        <span v-if="player.wins != 0">
                                                            <span>{{ player.wins }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="column is-1">
                                                        <span v-if="player.bullseyes != 0">
                                                            <span>{{ player.bullseyes }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="column is-2">
                                                        <span>{{ player.average }}</span>
                                                    </div>
                                                    <div class="column is-2">
                                                        <span>{{ player.total }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-if="sortFinalPlayers == 'custom'">
                                            <div class="columns is-mobile">
                                                <div class="column is-8">Player</div>
                                                <div class="column is-1"><i class="fas fa-award winner"></i></div>
                                                <div class="column is-1"><i class="fas fa-bullseye"></i></div>
                                                <div class="column is-1">Avg</div>
                                                <div class="column is-1">Tot</div>
                                            </div>
                                            <div v-for="(player, index) in this.playersList" :player="player" :key="player.id">
                                                <div v-if="player.name != ''">
                                                    <div class="columns is-mobile">

                                                        <div class="column is-6">
                                                            <span style="display: inline; float: left;">
                                                                <label class="checkbox">
                                                                    <input class="custom_checkbox" type="checkbox" v-bind:id="player.id" v-model="player.selectedForFinals">
                                                                </label>
                                                            </span>
                                                            <span style="display: inline; float: left;">
                                                                &nbsp;{{ (index+1) }}
                                                            </span>
                                                            <span style="display: inline; float: left;">
                                                                <label  v-bind:for="player.id">
                                                                    &nbsp;{{ player.given_name || player.name}} 
                                                                </label>
                                                            </span>
                                                        </div>

                                                        <div class="column is-1 has-text-right">
                                                            <span v-if="index != 0" alt="move up" v-on:click="movePlayer(index, 'up')">
                                                                <i class="fas fa-chevron-up"></i> 
                                                            </span>
                                                        </div>
                                                        <div class="column is-1">
                                                            <span v-if="index != (gameData.players.length-1)" alt="move down" v-on:click="movePlayer(index, 'down')">
                                                                <i class="fas fa-chevron-down"></i> 
                                                            </span>
                                                        </div>
                                                        <div class="column is-1">
                                                            <span v-if="player.wins != 0">
                                                                <span>{{ player.wins }}</span>
                                                            </span>
                                                        </div>
                                                        <div class="column is-1">
                                                            <span v-if="player.bullseyes != 0">
                                                                <span>{{ player.bullseyes }}</span>
                                                            </span>
                                                        </div>
                                                        <div class="column is-1">
                                                            <span>{{ player.average }}</span>
                                                        </div>
                                                        <div class="column is-1">
                                                            <span>{{ player.total }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                    

                                <br/>

                                <div v-if="gameData.gameType ==  GameType.TOURNAMENT">
                                    <ThrowSettings  
                                        :gameData="gameData" 
                                        :sets="sets"
                                        :rounds="rounds"
                                        :throws="throws"
                                        :targets="targets"/>
                                </div>                                

                                <br/>
                                
                                <a class="button is-danger" v-on:click="buildFinals">Start Finals!</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="(gameData.gameType === GameType.ROUNDROBIN || gameData.gameType ===  GameType.TOURNAMENT) && !hasFinals && !showFinalsPlayerSelection">
                        <br/>
                        <br/>
                        <div class="box rankings">
                            <h1 class="is-size-3">Rankings</h1>
                            <h1 class="subtitle">Game in Progress</h1>
                            <div v-for="(player, index) in this.playersSortedByAverage" :player="player" :key="player.player">
                                <div class="columns is-mobile">
                                    <div class="column is-1">
                                        {{ (index+1) }}
                                    </div>
                                    <div class="column is-5">
                                        <label  v-bind:for="player.id">
                                            {{ player.given_name || player.name}} 
                                        </label>
                                    </div>
                                    <div class="column is-3">
                                        Avg <span>{{ player.average }}</span>
                                    </div>
                                    <div class="column is-3">
                                        Total <span>{{ player.total }}</span>
                                    </div>
                                </div>
                            </div>
                            <br/>
                        </div>
                        <br/>
                        <br/>
                    </div>

                    <div class="columns no-print">
                        <div class="column">
                            <div class="score-button">
                                <a class="button is-danger" v-on:click="resetScoreCard">Reset</a>
                            </div>
                            <div class="score-button">
                                <a class="button is-info" v-on:click="printScoreCard">Print</a>
                            </div>
                            <div class="score-button">
                                <a class="button is-success" v-on:click="submitScoreCard">Submit</a>
                            </div>
                            <!--
                            <div class="score-button">
                                <a class="button is-success" v-on:click="submitScoreCard">Share???</a>
                            </div>
                            -->
                        </div>
                    </div>

                    <div v-if="gameData.gameType ===  GameType.TOURNAMENT && hasFinals && !finalsLocked">
                        <div>
                            <a class="button is-success" v-on:click="lockFinals">Done Finals</a>
                        </div>
                    </div>

                    <div v-if="gameData.gameType === GameType.ROUNDROBIN && hasFinals && finalsLocked">
                        <br/>
                        <h4 class="is-size-2 finals-heading">GAME SUMMARY</h4>
                        <GameSummary ref="gameSummary" v-bind:gameData="gameData"/> 
                    </div>

                    <div v-if="gameData.gameType === GameType.SOLO">
                        <br/>
                        <h4 class="is-size-2 finals-heading">GAME SUMMARY</h4>
                        <GameSummary ref="gameSummary" v-bind:gameData="gameData"/> 
                    </div>

                    <div v-if="gameData.gameType ===  GameType.TOURNAMENT && finalsLocked">
                        <br/>
                        <h4 class="is-size-2 finals-heading">GAME SUMMARY</h4>
                        <GameSummary ref="gameSummary" v-bind:gameData="gameData"/> 
                    </div>

                </div>
            </div>

        </div>
        <br/> 
        <br/> 
        <br/> 
        <br/> 
        <br/> 
        <a @click="showMoodModal">.</a>
    </div>

</template>

<script>
import emptygame from '../json/emptygame.json'
import Round from '@/components/Round';
import RoundEmpty from '@/components/RoundEmpty';
import axios from "axios";
import moment from 'moment';
import AdModal from "../components/AdModal.vue";
import MoodModal from "../components/MoodModal.vue";
import GameSummary from "../components/GameSummary.vue";
import router from '../router'
import ThrowSettings from '../components/partials/ThrowSettings.vue';
import {v4 as uuidv4} from 'uuid';
import { GameType } from '../enum/gameType.js';

export default {
  name: 'play',
    beforeRouteLeave (to, from, next) {
        //navigation guard (back/forward navigation; refresh functionality attached to window below in plain JS)
        this.confirmLeaving(to, from, next);
    },
    components : {
        Round,
        RoundEmpty,
        AdModal,
        MoodModal,
        GameSummary,
        ThrowSettings
    },
    filters: {
        formatId: function (value) {
            if (!value) return '';
            value = value.toString();
            return value.substring(value.indexOf("_")+1, value.length);
        }
    },
    computed: {
        finalRounds() {
            var finalsSchema = this.getFinalSchemaRounds();
            var rnds = [];
            if (finalsSchema != null) {
                for(var x = 0; x < finalsSchema.Rounds.length; x++) {
                    var rnd = finalsSchema.Rounds[x];
                    for(var y = 0; y < rnd.Matches.length; y++) {
                        var mtch = rnd.Matches[y];
                        mtch.player1name = this.getMatchPlayerName(mtch.player1, finalsSchema.Rounds);
                        mtch.player2name = this.getMatchPlayerName(mtch.player2, finalsSchema.Rounds);
                    }
                    rnds.push(finalsSchema.Rounds[x]);
                }
            }
            return rnds;
        },
        roundsRemaining() {
            // this isn't working....
            //console.log("### calculate roundsRemaining:")

            //console.log("### getFinalRounds:")
            var finals = this.getFinalRounds();
            //console.log("final rounds:", finals);

            //console.log("### getFinalSchemaRounds:")
            var finalsSchema = this.getFinalSchemaRounds();
            //console.log("final schema rounds:", finalsSchema);
            
            var rnds = [];
            for(var x = finals.length; x < finalsSchema.Rounds.length; x++) {
                var rnd = finalsSchema.Rounds[x];
                for(var y = 0; y < rnd.Matches.length; y++) {
                    var mtch = rnd.Matches[y];
                    mtch.player1name = this.getMatchPlayerName(mtch.player1, finalsSchema.Rounds);
                    mtch.player2name = this.getMatchPlayerName(mtch.player2, finalsSchema.Rounds);
                }
                rnds.push(finalsSchema.Rounds[x]);
            }
            this.roundsComponentKey++;
            //console.log("### roundsRemaining:",rnds)
            return rnds;
        },
        playersSortedByAverage() {
            this.rankingsRefeshKey;
            //console.log("playersSortedByAverage");
            //calculate
            for (var i = 0; i < this.gameData.players.length; i++) {
                this.gameData.players[i].average = this.$parent.calculateAverageThrow(this.gameData.players[i],this.gameData)
                this.gameData.players[i].total = this.$parent.calculateTotalThrows(this.gameData.players[i],this.gameData)
                this.gameData.players[i].bullseyes = this.$parent.calculateTotalBullseyes(this.gameData.players[i],this.gameData)
                this.gameData.players[i].wins = this.$parent.calculateTotalWins(this.gameData.players[i],this.gameData)
                //console.log("calculating average: " + this.gameData.players[i].average);
            }
            var playersArr = this.cloneAsObject(this.gameData.players);
            playersArr = playersArr.filter(item => item.name !== "");

            playersArr.sort(this.sortByAverageThrow);
            return playersArr;
        },
        playersList() {
            this.rankingsRefeshKey;
            var playersArr = this.gameData.players.filter(item => item.name !== "");
            return playersArr;
        },
        hasFinals() {
            this.refreshKey;
            if (this.gameData.gameType === GameType.TOURNAMENT) {
                //console.log("computing hasFinals for tournanment");
                for (var z = 0; z < this.gameData.sets.length; z++) {
                    //console.log("set:");
                    //console.log(this.gameData.sets[z]);
                    var st = this.gameData.sets[z];
                    if (st.type != null && st.type === 'Finals') return true;
                    //for (var i = 0; i < st.rounds.length; i++) {
                    //    if (st.rounds[i].type === 'Finals') return true;
                    //}
                }
            } else {
                for (var i = 0; i < this.gameData.rounds.length; i++) {
                    if (this.gameData.rounds[i].type === 'Finals') return true;
                }
            }
            return false;
        },
        allowAddrounds: function() {
            var totalSchemaRounds = this.totalSchemaRounds();
            var totalRounds = this.totalRounds();
            return (totalSchemaRounds === totalRounds ? false : true);
        }
    },
    data () {
        return {
            GameType, // Import the enum here to make it accessible in the template
            debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
            isLoading: true,
            isStarted: false,
            publicPath: process.env.BASE_URL,
            isAdModalVisible: false,
            isMoodModalVisible: false,
            isMoodBoxOpen: false,
            gameData: emptygame,
            axes2Schema: null,
            axes2SchemaOriginal: null,
            points: 0,
            rounds: '6',
            throws: '6',
            league: '',
            targets: '6',
            sets: '3',
            axe: '',
            dateDisplay: '',
            isSubscribed: false,
            subscriptionChecked: false,
            subscriptionId: '',
            roundsLocked: false,
            finalsLocked: false,
            scorecardSubmitted: false,
            showPlayerManagement: false,
            nextRoundNumber: 0,
            isCoachInfoDisplayed: false,
            axe_list: [],
            profile: new Axes2Profile("0","","","","","","","",""),
            componentKey: 0,
            showFinalsPlayerSelection: false,
            sortFinalPlayers: 'avg',
            weather: null,
            refreshKey: 0,
            rankingsRefeshKey: 0,
            liveLoggingEnabled: true,
            tournamentKey: 0,
            playersModified: false,
            showBookingFeature: false,
            booking_data: [],
            /*booking_data_message: [],*/
            locationPicked: '',
            lanePicked: '',
            roundsComponentKey: 0,
            savedGamesInProgress: [],
            pleaseWait: false
        }
    },    
    methods:{
        handleFileUpload(event) {
            this.selectedFile = event.target.files[0];
        },
        async submitForm() {
            if (!this.selectedFile) {
                alert("Please select a file first.");
                return;
            }

            const formData = new FormData();
            formData.append("image", this.selectedFile);

            this.pleaseWait = true;

            let token = this.$parent.getApiToken();

            try {
                let url = "https://axes2-docintel-bganefftbdabftcc.canadaeast-01.azurewebsites.net/upload"
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        'authorization': token
                    },
                    body: formData,
                });
                
                const result = await response.json();
                
                //console.log("Upload successful:", result);
                
                //clear form data
                this.selectedFile = null;
                this.previewUrl = null;

                //eeset the file input element
                this.$refs.fileInput.value = "";

                //alert(JSON.stringify(result));
                let newPlayersList = [];

                for (var i = 0; i < result.length; i++) {
                    if (result[i] != null) {

                        var player_uuid = uuidv4();

                        var p = new this.$playerClass(
                            player_uuid, "", result[i].person_name, "", "", "", "", false);

                        newPlayersList.push(p);
                    }
                }

                this.gameData.players = newPlayersList;

                this.pleaseWait = false;

            } catch (error) {
                console.error("Upload failed:", error); 

                alert("upload failed");
                this.pleaseWait = false;
            }
        },
        
        addPlayers(amount) {
            console.log("addPlayers", amount);
            if (amount != null && amount > 0) {
                for(var i = 0; i < amount; i++) {

                    var player_uuid = uuidv4();

                    //id, nickname, name, given_name, family_name, email, picture
                    var p = new this.$playerClass(player_uuid, "", "", "", "", "", "", true);

                    console.log("adding new player", p);

                    this.gameData.players.push(p);
                }
            }
        },
        setSets(sets) {
            this.sets = sets;
        },
        setRounds(rounds) {
            this.rounds = rounds;
        },
        setThrows(thrws) {
            this.throws = thrws;
        },
        setTargets(targets) {
            this.targets = targets;
        },
        setMood(mood) {
            this.gameData.mood.feel = mood;
        },
        toggleMoodBox() {
            this.isMoodBoxOpen = !this.isMoodBoxOpen;
        },
        toggleEmailVisibility(player) {
            //console.log("toggleEmailVisibility",player);
            player.emailVisible = !player.emailVisible;
        },
        getMatchPlayerName(player, finalRounds) {
            //console.log("getMatchPlayerName", player);
            if (isNaN(player)) {
                //it's either going to be a BYE or player in the format of R2M3 (Round 2 Match 3)
                if (player === "bye") {
                    return player;
                } else {

                    var rnd_temp = player.substring(1,2);
                    var mtch_temp = player.substring(3,4);

                    var rndDisplay;
                    var mtchDisplay;

                    if (finalRounds != null) {
                       for (var a = 0; a < finalRounds.length; a++) {
                            var rnd = finalRounds[a];
                            if (rnd.originalRoundId == rnd_temp) {
                                for (var b = 0; b < rnd.Matches.length; b++) {
                                    var mtch = rnd.Matches[b];
                                    if (mtch.originalMatchId == mtch_temp) {
                                        rndDisplay = a+1;
                                        mtchDisplay = b+1;
                                    }
                                }
                            }
                        }
                    }
         
                    //tODO this doesn't seem to be working when it should
                    var prevWinnerId = this.findFinalRoundMatchWinner(rnd_temp, mtch_temp);
                    if (prevWinnerId == null) {
                        return "Winner of Finals Round " + rndDisplay + " Match " + mtchDisplay;
                    } else {
                        var plr = null;
                        //find the winning player (if the match has already been played)
                        for (var x = 0; x < this.gameData.finalPlayers.length; x++) {
                            var p = this.gameData.finalPlayers[x];
                            if (p.id === prevWinnerId) {
                                plr = p;
                            }
                        } 
                        return "Winner of Finals Round " + rndDisplay + " Match " + mtchDisplay + ": " + plr.name;
                    }   
                }
            } else {
                return this.gameData.finalPlayers[player-1].name;
            }
        },
        userNameDisplay(player) {
            if (player.user.name != null && player.user.name.indexOf("@") == -1) {
                return player.user.name;
            } else if (player.user.nickname != null && player.user.nickname != "") {
                return player.user.nickname;
            } else {
                return player.user.email;
            }
        },      
        signInDateDisplay: function(datetimestamp) {
            return moment(this.datetimestamp).local().format('YYYY-MM-DD');
        },
        getSigninsByTeam: function (timeslot_guid) {
            var url = (this.debugMode ? "http://localhost:8080/signin/" : "https://axes2api.azurewebsites.net/signin/")
            url += timeslot_guid;

            var token = this.$parent.getApiToken();

            this.pleaseWait = true;
            //this.signins_by_team = [];

            axios.get(url,{
                headers: {
                    authorization: token
                }
            })
            .then((response) => {
                if (response.data.error != null) {
                    //this.errorMessage = response.data.error;
                    //this.showError = true;
                    //this.pleaseWait = false;
                } else {
                    if (response.data.length === 0) {
                        //this.signins_by_team = [];
                    } else {
                        var booking_data = this.booking_data[0];
                        //add players to timeslot data
                        booking_data.bookings.lanes.forEach( (lane) => {
                            lane.teams.forEach( (team) => {
                                if (team.timeslot_guid === timeslot_guid) {
                                    team.players = response.data;
                                }
                            })
                        });
                        //this.signins_by_team = response.data; 
                    }
                    //this.pleaseWait = false;
                }
            }, (error) => {
                //this.errorMessage = error;
                //this.showError = true;
                //this.pleaseWait = false;
            });
        },
        removePlayerSignin: function(team, player) {
            /*
            console.log("removePlayerSignin:");
            console.log("team:");
            console.log(team);
            console.log("player:");
            console.log(player);
            */

            var url = (this.debugMode ? "http://localhost:8080/signin/" : "https://axes2api.azurewebsites.net/signin/")
            url += player._id;
            
            //console.log("removePlayerSignin url:" + url);

            var token = this.$parent.getApiToken();

            axios.delete(url, {
            headers: {
                authorization: token
            },
            data: {
            }
            }).then((response) => {
                
                team.players.splice(player);

                alert('Sign-in Deleted.');
                
            }, (error) => {
                alert("Error deleting Sign-in.");
                console.log(error);
            });
        },
        setTeam: function(lane_id, team_id, team_name, timeslot_guid, timeslot) {
            
            this.gameData.title = team_name;
            this.showBookingFeature = false;

            this.gameData.players = [];

            var url = (this.debugMode ? "http://localhost:8080/signin/" : "https://axes2api.azurewebsites.net/signin/")
            url += timeslot_guid;

            var token = this.$parent.getApiToken();

            axios.get(url,{
                headers: {
                    authorization: token
                }
            })
            .then((response) => {
                if (response.data.error != null) {
                    this.errorMessage = response.data.error;
                    this.showError = true;
                    this.pleaseWait = false;
                } else {
                    if (response.data.length === 0) {
                        //this.signins_by_team = [];
                    } else {
                        var booking_data = this.booking_data[0];
                        //add players to timeslot data
                        booking_data.bookings.lanes.forEach( (lane) => {
                            lane.teams.forEach( (team) => {
                                if (team.timeslot_guid === timeslot_guid) {
                                    var players = response.data;
                                    //-console.log("got players");
                                    //console.log(players);
                                    //fill out players list
                                    for (var i = 0; i < players.length; i++) {
                                        //console.log(players[i]);

                                        var plyr = players[i];

                                        var player_uuid = uuidv4();

                                        //id, nickname, name, given_name, family_name, email, picture
                                        var p = new this.$playerClass(player_uuid, plyr.user.nickname,
                                            plyr.user.name, plyr.user.given_name, plyr.user.family_name, 
                                            plyr.user.email, plyr.user.picture, false);

                                        if (this.gameData.players == null) this.gameData.players = [];
                                        this.gameData.players.push(p);
                                        //
                                    }
                                }
                            })
                        });
                    }
                }
            }, (error) => {
                //this.errorMessage = error;
                //this.showError = true;
                //this.pleaseWait = false;
            });
            //
            //
        },
        getBookingsForToday: function () {
            var daydate = moment().local().format('YYYY-MM-DD');

            if (this.locationPicked != '' && this.lanePicked != '') {
                var url = (this.debugMode ? "http://localhost:8080/bookings/" : "https://axes2api.azurewebsites.net/bookings/")
                url += daydate;
                url += "/" + this.locationPicked;

                var token = this.$parent.getApiToken();

                //this.pleaseWait = true;
                this.booking_data = [];

                axios.get(url,{
                    headers: {
                        authorization: token
                    }
                })
                .then((response) => {
                    if (response.data.error != null) {
                        //this.errorMessage = response.data.error;
                        //this.showError = true;
                        //this.pleaseWait = false;
                    } else {
                        if (response.data.length === 0) {
                            this.booking_data = [];
                            //this.booking_data_message = 'No bookings found for today.';
                        } else {
                            this.booking_data = response.data; 
                        }
                        //this.pleaseWait = false;
                    }
                }, (error) => {
                    //this.errorMessage = error;
                    //this.showError = true;
                    //this.pleaseWait = false;
                });
            }
        },        
        openNextRound(round_number, match_number) {
            if (this.playersModified && this.validatePlayers()) {
                this.playersModified = false;
                var newSetsArr = this.generateTournament(false);

                //overwrite entries in the new array with any old ones.
                var firstOne = true;
                //console.log("overwriting entries in the new array with entries from the old one");
                //console.log(newSetsArr);
                //console.log(this.gameData.sets);
                for (var i = 0; i < newSetsArr.length; i++) {
                    for (var x = 0; x < newSetsArr[i].rounds.length; x++) {
                        for (y = 0; y < newSetsArr[i].rounds[x].matches.length; y++) {

                            if (this.gameData.sets[i] &&
                                this.gameData.sets[i].rounds[x] && 
                                this.gameData.sets[i].rounds[x].matches[y] && 
                                this.gameData.sets[i].rounds[x].matches[y].completed) {
                                newSetsArr[i].rounds[x].matches[y] = this.gameData.sets[i].rounds[x].matches[y];
                            } else {
                                //if there's nothing to overwrite
                                //ignore this match if the first match is completed.
                                if (this.gameData.sets[i] &&
                                    this.gameData.sets[i].rounds[x] &&
                                    this.gameData.sets[i].rounds[x].matches[0] &&
                                    this.gameData.sets[i].rounds[x].matches[0].completed === true) {

                                    //ignore this one

                                } else {
                                    if (firstOne) {
                                        newSetsArr[i].rounds[x].matches[y].display = true;
                                        newSetsArr[i].rounds[x].matches[y].matchPlayers[0].throws[0].isActive = true;
                                        firstOne = false;

                                        var m = {
                                            uniqueItemId: newSetsArr[i].rounds[x].matches[y].uniqueId,
                                            uniqueId: this.gameData.uniqueId,
                                            match: newSetsArr[i].rounds[x].matches[y],
                                            title: this.gameData.title,
                                            league: this.gameData.league,
                                            lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                                        }

                                        this.sendBroadcastControlMessage('match', m, 'New Match','openNextRound');
                                    }
                                }
                            }
                        }
                    }
                }
                this.gameData.sets = newSetsArr;
            } else {
                //toggle the next match
                var found = false;
                for (var x = 0; x < this.gameData.sets.length; x++) {
                    for (var y = 0; y < this.gameData.sets[x].rounds.length; y++) {
                        var rnd = this.gameData.sets[x].rounds[y];
                        if (!found && rnd.id == round_number) {
                            var m = rnd.matches[0];
                            m.matchPlayers[0].throws[0].isActive = true;
                            m.display = true;
                            found = true;
                        }
                    }
                }
            }
        },
        addLocationWeatherMessage(control_value) {
            if (this.gameData.weather != null) {
                var ctrl_val = JSON.parse(control_value);
                var weather = this.gameData.weather;
                var locationDescription = (weather.name ? weather.name : "") + " " + (weather.sys? (weather.sys.country? weather.sys.country: "") : "");
                var weatherDescription = (weather.main? ( weather.main.temp? Math.round(weather.main.temp)+"c" : "") : "");
                weatherDescription += " " + (weather.weather[0] ? (weather.weather[0].main ? weather.weather[0].main : "") : "");
                weatherDescription += ", " + (weather.wind ? (weather.wind.speed ? "wind " + Math.round(weather.wind.speed)+"km" : "") : "");
                ctrl_val.weather = weatherDescription;
                ctrl_val.location = locationDescription;
                control_value = JSON.stringify(ctrl_val);
            }
            return control_value;
        },
        getNextUp(control_value) {
            var nextUpString = '';

            var id = control_value.match.id;
            if (id != null && id.indexOf('_') != -1) {

                var isFinals = false;
                var rndArr = id.split("_");
                var round_number = null;
                var match_number = null;

                var nextRoundNumber = 0;
                var nextMatchNumber = 0;
                var next = null;

                if (id.indexOf('Finals') != -1) {
                    isFinals = true;
                    round_number = parseInt(rndArr[0]);
                    match_number = parseInt(rndArr[2]);

                    next = this.getNext(isFinals, round_number, match_number);
                    if (next != null && next.indexOf('_') != -1) {
                        next = next.replace("Finals_","")
                        var nextArr = next.split("_");
                        nextRoundNumber = parseInt(nextArr[0]);
                        nextMatchNumber = parseInt(nextArr[1]);
                    }

                    if (nextRoundNumber != 0 && nextMatchNumber != 0) {
                        var nextM = this.getFinalsMatch(nextRoundNumber, nextMatchNumber, GameType.ROUNDROBIN);
                        if (nextM != null) {
                            var player1 = this.playerName(nextM.matchPlayers[0]);
                            var player2 = this.playerName(next_match.matchPlayers[1]);
                            nextUpString = player1 + ' vs ' + player2;
                        } else {
                            //rounds that are not yet constructed
                            var rndsFinal = this.finalRounds;
                            var rnds = rndsFinal.filter((round) => round.originalRoundId == nextRoundNumber);
                            if (rnds.length > 0) {
                                var mtchs = rnds[0].Matches.filter((match) => match.originalMatchId == nextMatchNumber);
                                if (mtchs.length > 0) {
                                    nextUpString = mtchs[0].player1name + ' vs ' + mtchs[0].player2name;
                                }
                            }
                        }
                    }
                } else {
                    round_number = parseInt(rndArr[0]);
                    match_number = parseInt(rndArr[1]);

                    next = this.getNext(isFinals, round_number, match_number);
                    if (next.indexOf('_') != -1) {
                        var nextArr = next.split("_");
                        nextRoundNumber = parseInt(nextArr[0]);
                        nextMatchNumber = parseInt(nextArr[1]);
                    }

                    if (nextRoundNumber != 0 && nextMatchNumber != 0) {
                        var next_match = this.getMatch(nextRoundNumber, nextMatchNumber, GameType.ROUNDROBIN);
                        if (next_match != null) {
                            var player1 = this.playerName(next_match.matchPlayers[0]);
                            var player2 = this.playerName(next_match.matchPlayers[1]);

                            nextUpString = player1 + ' vs ' + player2;
                        }
                    }
                }
            }
            return nextUpString;
        },
        sendBroadcastControlMessage(control_type, control_value, title, source) {
            if (this.gameData.liveLoggingEnabled && (this.gameData.gameType ===  GameType.TOURNAMENT || this.gameData.gameType === GameType.ROUNDROBIN)) {
                //get NextUp for lane display
                if (control_type === 'match') {
                    control_value.nextUp = this.getNextUp(control_value);                    
                }
                this.$parent.submitBroadcastControl('{ "control_type": "' + control_type + '", "control_value": ' + JSON.stringify(control_value) + ', "title" : "' + title + '", "source" : "' + source + '" }');
            } else {
                //console.log("message not sent.");
            }
        },
        setFinalPlayerSort(sort_type) {
            this.sortFinalPlayers = sort_type;
        },
        movePlayer(index, direction) {
            //console.log("move player index " + index + " " + direction);
            var f = this.gameData.players.splice(index, 1)[0];
            //console.log("moving player:");
            //console.log(f);

            if (direction == 'up') {
                    this.gameData.players.splice(index-1, 0, f);
            } else {
                this.gameData.players.splice(index+1, 0, f);
            }
            //this.rankingsRefeshKey;
        },
        generateUniqueId() {
            var d = new Date().getTime();//Timestamp
            var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16;//random number between 0 and 16
                if(d > 0){//Use timestamp until depleted
                    r = (d + r)%16 | 0;
                    d = Math.floor(d/16);
                } else {//Use microseconds since page-load if supported
                    r = (d2 + r)%16 | 0;
                    d2 = Math.floor(d2/16);
                }
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        },
        forceRerender() {
            this.componentKey += 1;
        },
        closeCoachInfo() {
            this.isCoachInfoDisplayed = false;
        },
        showCoachInfo() {
            this.isCoachInfoDisplayed = true;
        },
        hasTournamentFinals() {
            this.refreshKey;
            if (this.gameData.gameType ===  GameType.TOURNAMENT) {
                //console.log("computing hasFinals for tournanment");
                for (var z = 0; z < this.gameData.sets.length; z++) {
                    //console.log("set:");
                    //console.log(this.gameData.sets[z]);
                    var st = this.gameData.sets[z];
                    if (st.type != null && st.type === 'Finals') return true;
                }
            }
            return false;
        },
        getAxeList(gameType) {
            //console.log("getAxeList debugMode: " + this.debugMode);
            var token = this.$parent.getApiToken();
            var url = (this.debugMode ? "http://localhost:8080/axe_list" : "https://axes2api.azurewebsites.net/axe_list")
            axios.get(url, {
                headers: {
                    authorization: token
                }
            })
            .then((response) => {
                this.axe_list = response.data.axes;
            }, (error) => {
                //console.log(error);
            });
        },
        confirmLeaving(to, from, next) {
            //check game is complete?
            if (this.scorecardSubmitted) {
                //scorecard is submitted, no need to ask the user
                next();
            } else {
                if (confirm("Are you sure you want to leave?  Your scorecard has not been submitted.")) {
                    next();
                } else {
                    next(false);
                }
            }
        },
        getAxes2Schema() {
            var token = this.$parent.getApiToken();

            //var url = (this.debugMode ? "http://localhost:8080/schema/Axes2" : "https://axes2api.azurewebsites.net/schema/Axes2");
            var url = (this.debugMode ? "http://localhost:8080/schema/Axes2v2?v=19p" : "https://axes2api.azurewebsites.net/schema/Axes2v2?v=19p");
            axios.get(url,{
                    headers: {
                        authorization: token
                    }
                })
                .then((response) => {
                    this.axes2SchemaOriginal = response.data;
                }, (error) => {
                    alert("Error retrieving Axes2 Schema.\n\n" + error.toString())
                });
        },
        totalSchemaRounds() {
            var schema = this.axes2Schema;
            var totalSchemaRounds = 0;
            for (var i = 0; i < schema.Brackets.length; i++) {
                var game = schema.Brackets[i];
                if (game.Players === this.gameData.players.length) {
                    if (game.Rounds != null) {
                        totalSchemaRounds = game.Rounds.length;
                    }
                }
            }
            return totalSchemaRounds;
        },
        totalRounds() {
            var total = 0;
            if (this.gameData.rounds != null) {
                total = this.gameData.rounds.length;
            }   
            return total;
        },
        totalSchemaFinalRoundsMatches(currentRoundNumber) {

            var schema = this.axes2SchemaOriginal;

            var numRounds = this.rounds;
            var numThrows = this.throws;
            var numPlayers = this.gameData.finalPlayers.length;

            schema = this.parseSchema(numRounds, numThrows, numPlayers, schema)

            var totalSchemaFinalRoundMatches = 0;
            for (var i = 0; i < schema.Brackets.length; i++) {
                var game = schema.Brackets[i];
                var players = (this.gameData.finalPlayers != null ? this.gameData.finalPlayers : this.gameData.players);
                if (game.Players === players.length) {
                    if (game.Finals != null) {
                        var round = game.Finals.Rounds[currentRoundNumber-1];
                        if (round) {
                            totalSchemaFinalRoundMatches = round.Matches.length;
                        }
                    }
                }
            }
            return totalSchemaFinalRoundMatches;
        },
        totalSchemaFinalRounds() {
            var schema = this.axes2SchemaOriginal;

            var numRounds = this.rounds;
            var numThrows = this.throws;
            var numPlayers = (this.gameData.finalPlayers != null ? this.gameData.finalPlayers.length : 0);

            var totalSchemaFinalRounds = 0;
            if (numPlayers != 0) {
                schema = this.parseSchema(numRounds, numThrows, numPlayers, schema)

                for (var i = 0; i < schema.Brackets.length; i++) {
                    var game = schema.Brackets[i];
                    var players = (this.gameData.finalPlayers != null ? this.gameData.finalPlayers : this.gameData.players);
                    if (game.Players === players.length) {
                        if (game.Finals != null) {
                            totalSchemaFinalRounds = game.Finals.Rounds.length;
                        }
                    }
                }
            }
            return totalSchemaFinalRounds;
        },
        getFinalSchemaRounds() {
            var schema = this.axes2SchemaOriginal;

            var numRounds = this.rounds;
            var numThrows = this.throws;
            var numPlayers = this.gameData.finalPlayers.length;

            schema = this.parseSchema(numRounds, numThrows, numPlayers, schema)

            var schemaFinalRounds = 0;
            for (var i = 0; i < schema.Brackets.length; i++) {
                var game = schema.Brackets[i];
                if (game.Players === this.gameData.finalPlayers.length) {
                    if (game.Finals != null) {
                        schemaFinalRounds = game.Finals;
                    }
                }
            }
            return schemaFinalRounds;
        },
        getFinalRounds() {
            //console.log("... getFinalRounds");
            var finals = [];
            if (this.gameData.rounds != null) {
                this.gameData.rounds.forEach(round => {
                    if (round.type === "Finals") finals.push(round);;
                });
            }   
            //console.log(finals);
            return finals;
        },
        lastFinalRoundMatchNumber() {
            var numMatches = 0;
            var finalRounds = this.getFinalRounds();
            if (finalRounds != null) {
                var lastRound = finalRounds[finalRounds.length-1];
                if (lastRound != null && lastRound.matches != null) numMatches = lastRound.matches.length;
            }   
            return numMatches;
        },
        totalFinalRounds() {
            var totalFinal = 0;
            if (this.gameData.rounds != null) {
                this.gameData.rounds.forEach(round => {
                    if (round.type === "Finals") totalFinal++;
                });
            }   
            return totalFinal;
        },
        sortByAverageThrow(a, b) {
            if (a.average < b.average)
              return 1;
            if (a.average > b.average)
              return -1;
            return 0;
        },
        isSuper() {
            return this.$parent.isSuper();
        },
        isAdmin() {
            return this.$parent.isAdmin();
        },
        getCountFinalPlayers() {
            var numPlayers = (this.gameData.finalPlayers != null ? this.gameData.finalPlayers.length : 0);
            return numPlayers;
        },
        areFinalsCompleted() {
            //console.log("Throw->areFinalsCompleted?");
            var totalSchemaFinalRounds = this.totalSchemaFinalRounds();
            var totalFinalRounds = this.totalFinalRounds();
            //console.log("areFinalsCompleted?");
            //console.log("  totalSchemaFinalRounds: " + totalSchemaFinalRounds + ", totalFinalRounds: " + totalFinalRounds);
            if (totalSchemaFinalRounds === totalFinalRounds) {
                return true;
            } else {
                return false;
            }
        },
        lockFinals() {
            //console.log("Throw: lockFinals");
            if (this.gameData.gameType ===  GameType.TOURNAMENT) {
                if (confirm("Are you sure Finals are completed?")) {
                    var sts = this.gameData.sets;
                    var last_set = sts[sts.length-1];
                    var last_round = last_set.rounds[last_set.rounds.length-1];
                    var last_match = last_round.matches[last_round.matches.length-1];
                    //console.log(last_match);
                    last_match.completed = true;
                    last_match.display = false;

                    this.finalsLocked = true;
                    this.forceRerender();
                }

                this.saveGameInProgress( GameType.TOURNAMENT);

            } else if (this.gameData.gameType === GameType.ROUNDROBIN) {
                this.finalsLocked = true;
                this.forceRerender();

                var msg = {
                    message: "Game Completed",
                    uniqueId: this.gameData.uniqueId,
                    uniqueItemId: this.generateUniqueId(),
                    title: this.gameData.title,
                    league: this.gameData.league,
                    lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                }
                this.sendBroadcastControlMessage('game_completed', msg, 'Game Completed','lockFinals');

                this.saveGameInProgress(GameType.ROUNDROBIN);

            } else {
                this.finalsLocked = true;
                this.forceRerender();
            }
        },
        //open next match and build finals call this
        getNext: function(isFinals, currentRound, currentMatch) {
            //if currentRound === 0 && currentMatch === 0, get the first round/match available.
            if (isFinals) {

                if (currentRound === 0 && currentMatch === 0) {
                    return "1_1";
                }

                //get the current round and match:
                var curRound;
                var curMatch;
                var matchIdString = currentRound + "_Finals_" + currentMatch;
                var rounds = this.gameData.rounds;
                for (var x = 0; x < rounds.length; x++) {
                    var round = rounds[x]
                    var matches = round.matches;
                    for (var y = 0; y < matches.length; y++) {
                        var match = matches[y];
                        if (match.id === matchIdString) {
                            curRound = round;
                            curMatch = match;
                        }
                    }
                }

                var finalRounds = this.getFinalSchemaRounds().Rounds;

                //is there another match in this round?
                var anotherMatch = false;
                if (finalRounds[(currentRound-1)].Matches[currentMatch] != null) anotherMatch = true;

                //yes, return the next match
                if (anotherMatch) return currentRound + "_" + (currentMatch+1);

                //is there another round?
                var anotherRound = false;
                if (finalRounds[currentRound] != null) anotherRound = true;

                //yes, return the next round
                if (anotherRound) return ((currentRound+1) + "_Finals_1");
                else return "0_Finals_0";





            } else {

                if (currentRound === 0 && currentMatch === 0) {
                    return "1_1";
                }

                //get the current round:
                var curRound = this.gameData.rounds[currentRound-1];
                var curMatch = curRound.matches[currentMatch-1];

                //is there another match in this round?
                var anotherMatch = false;
                if (curRound.matches[currentMatch] != null) anotherMatch = true;

                //yes, return the next match
                if (anotherMatch) return currentRound + "_" + (currentMatch+1);

                //is there another round?
                var anotherRound = false;
                if (this.gameData.rounds[currentRound] != null) anotherRound = true;

                //yes, return the next round
                if (anotherRound) return ((currentRound+1) + "_1");
                else return "0_0";
            }
        },
        hasNextMatch(currentMatch) {
            var isFinals = (currentMatch.id.indexOf("Finals") != -1);
            if (!isFinals) {
                var matchId = (isFinals ?  (currentMatch.id.replace("Finals_","")) : currentMatch.id);

                var idArr = matchId.split("_");
                var currentRoundNumber = parseInt(idArr[0]);
                var currentMatchNumber = parseInt(idArr[1]);

                var nextString = this.getNext(isFinals, currentRoundNumber, currentMatchNumber);
                if (nextString === '0_0') {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }

        },
        countFinalSets() {
            var finals = [];
            if (this.gameData.sets != null) {
                this.gameData.sets.forEach(st => {
                    if (st.type && st.type === "Finals") {
                        finals.push(st);
                    }
                    /*
                    st.rounds.forEach(round => {
                        if (round.type === 'Finals') finals.push(round);
                    })
                    */
                })
            }
            return finals.length;
        },
        //called by match markMatchCompleted
        openNextMatch(currentMatch) {

            if (this.gameData.gameType ===  GameType.TOURNAMENT) {

                currentMatch.completed = true;
                currentMatch.display = false;

                //find the match with current unique id
                var nextMatch = null;
                var takeNextMatch = false;
                var nextRoundNumber = 0;
                for (var x = 0; x < this.gameData.sets.length; x++) {
                    for (var y = 0; y < this.gameData.sets[x].rounds.length; y++) {
                        var rnd = this.gameData.sets[x].rounds[y];
                        for (var z = 0; z < rnd.matches.length; z++) {
                            var m = rnd.matches[z];
                            if (takeNextMatch) {
                                nextMatch = m;
                                nextRoundNumber = rnd.id;
                                takeNextMatch = false;
                            }
                            if (m.uniqueId === currentMatch.uniqueId) {
                                takeNextMatch = true;
                            }
                        }
                    }
                }

                this.nextRoundNumber = nextRoundNumber;

                if (nextMatch != null && nextMatch.completed) {
                    //do nothing
                    //alert("do nothing");
                } else if (nextMatch != null) {
                    //alert("displayTournamentMatch");
                    this.displayTournamentMatch(nextMatch);
                } else {
                    //alert("check for finals")
                    var countFinals = this.countFinalSets();
                    //alert("countFinals" + countFinals);
                    if (countFinals === 0) {
                        //alert("no finals found")
                        //alert("Choose your players for finals");
                        this.showFinalsPlayerSelection = true;
                    } else {
                        //alert("hasTournamentFinals: " + this.hasTournamentFinals())
                        //if this is the last match in the current set, prompt the user
                        if (this.hasTournamentFinals()) {
                            //alert("addNextTournamentFinals if we're not on the first round of finals.");
                            if (confirm("Add another set to finals?")) {
                                //alert("add another set");

                                this.showFinalsPlayerSelection = true;
                                /*
                                this.addNextTournamentFinals();
                                */
                            }
                        }
                    }
                }
                this.forceRerender();

            } else {

                var isFinals = (currentMatch.id.indexOf("Finals") != -1);
                var matchId = (isFinals ?  (currentMatch.id.replace("Finals_","")) : currentMatch.id);

                var idArr = matchId.split("_");
                var currentRoundNumber = parseInt(idArr[0]);
                var currentMatchNumber = parseInt(idArr[1]);

                var nextString = this.getNext(isFinals, currentRoundNumber, currentMatchNumber);
                nextString = nextString.replace("Finals_","")
                var nextArr = nextString.split("_");
                var nextRoundNumber = parseInt(nextArr[0]);
                var nextMatchNumber = parseInt(nextArr[1]);

                //hide current match
                this.toggleMatch(currentRoundNumber, currentMatchNumber, (isFinals ? "Finals" : ""), currentMatch.uniqueId);

                if (isFinals && nextRoundNumber === 0 && nextMatchNumber ===0) {
                    this.finalsLocked = true;
                } else if (isFinals) {
                    //don't add it if it already exists.
                    if (this.isNextRoundFinalsNeeded(currentRoundNumber, currentMatchNumber, nextRoundNumber, nextMatchNumber)) {
                        //add the next match (and round if needed)
                        this.addNextRoundRobinFinals(currentRoundNumber, currentMatchNumber, nextRoundNumber, nextMatchNumber);

                        var nextM = this.getFinalsMatch(nextRoundNumber, nextMatchNumber, GameType.ROUNDROBIN);

                        //broadcast to display
                        var m = {
                            uniqueItemId: nextM.uniqueId,
                            uniqueId: this.gameData.uniqueId,
                            match: nextM,
                            title: this.gameData.title,
                            league: this.gameData.league,
                            lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                        }

                        this.sendBroadcastControlMessage('match', m, 'New Match','openNextMatch');
                    }
                } else {

                    if (nextMatchNumber == 1) {
                        this.showPlayerManagement = true;

                        this.nextRoundNumber = nextRoundNumber;

                        //alert("this.showPlayerManagement: " + this.showPlayerManagement);

                        var nextM = this.getMatch(nextRoundNumber, nextMatchNumber, GameType.ROUNDROBIN);

                        //broadcast to display
                        var m = {
                            uniqueItemId: nextM.uniqueId,
                            uniqueId: this.gameData.uniqueId,
                            match: nextM,
                            title: this.gameData.title,
                            league: this.gameData.league,
                            lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                        }

                        this.sendBroadcastControlMessage('match', m, 'New Match','openNextMatch');
                    } else {

                        if (nextRoundNumber != 0 && nextMatchNumber != 0) {
                            this.displayMatch(nextRoundNumber, nextMatchNumber);

                            var nextM = this.getMatch(nextRoundNumber, nextMatchNumber, GameType.ROUNDROBIN);

                            //broadcast to display
                            var m = {
                                uniqueItemId: nextM.uniqueId,
                                uniqueId: this.gameData.uniqueId,
                                match: nextM,
                                title: this.gameData.title,
                                league: this.gameData.league,
                                lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                            }

                            this.sendBroadcastControlMessage('match', m, 'New Match','openNextMatch');


                        }
                    }
                }
            }
        },
        skipToFinals(round) {

            if (confirm("Are you sure you want to SKIP TO FINALS?")) {

                //remove any subsequent rounds
                if (this.gameData.gameType ===  GameType.TOURNAMENT) {

                    var sets = this.gameData.sets;
                    sets = this.removeRemainingSets(sets,round);
                    this.gameData.sets = sets;

                    this.showPlayerManagement = false;
                    this.showFinalsPlayerSelection = true;
                } else {
                    var rounds = this.gameData.rounds;
                    rounds = this.removeRemainingMatches(rounds, round);
                    this.gameData.rounds = rounds;

                    this.showPlayerManagement = false;
                    this.showFinalsPlayerSelection = true;
                }
            }
        },
        updateSets(sets) {
            this.gameData.sets = sets;
        },
        removeRemainingSets(sets, round) {
            if (sets != null) {
                for (var m = 0; m < sets.length; m++) {
                    var s = sets[m];

                    //for each round
                    var rounds = s.rounds
                    rounds = this.removeRemainingMatches(rounds, round);
                    s.rounds = rounds;
                }
            }

            var list_set_ids_to_delete = new Array();
            var add_to_list = false;
            for(var a = 0; a < sets.length; a++) {
                if (sets[a].rounds.length === 0) add_to_list = true;
                if (add_to_list) list_set_ids_to_delete.push(sets[a].id);
            }

            for(var b = 0; b < list_set_ids_to_delete.length; b++) {
                var set_id_to_delete = list_set_ids_to_delete[b];
                let i = sets.map(st => st.id).indexOf(set_id_to_delete);
                sets.splice(i, 1);
            }
            return sets;
        },
        removeRemainingMatches(rounds, round) {
            var list_round_ids_to_delete = new Array();
            var add_to_list = false;
            for(var a = 0; a < rounds.length; a++) {
                var rnd = rounds[a];
                for (var b = 0; b < rnd.matches.length; b++) {
                    var mtch = rnd.matches[b];
                    if (!mtch.completed) {
                        mtch.completed = true;
                        mtch.display = false;
                    }
                }
                //console.log("round:")
                if (rnd.id >= round.id) {
                    add_to_list = true;
                } else {
                    add_to_list = false;
                }
                if (add_to_list) list_round_ids_to_delete.push(rnd.id);
            }

            for(var b = 0; b < list_round_ids_to_delete.length; b++) {
                var round_id_to_delete = list_round_ids_to_delete[b];
                let i = rounds.map(rnd => rnd.id).indexOf(round_id_to_delete);
                rounds.splice(i, 1);
            }
            return rounds;
        },
        getMatch(round_number, match_number, game_type) {
            if (game_type === GameType.ROUNDROBIN) {
                for(var x = 0; x < this.gameData.rounds.length; x++) {
                    var round = this.gameData.rounds[x];
                    if (round.id === round_number) {
                        for (var y = 0; y < round.matches.length; y++) {
                            var mtch = round.matches[y];
                            if (mtch.id === round_number + "_" + match_number) {
                                return mtch;
                            }
                        }
                    }
                }
            }
            return null;           
        },
        getFinalsMatch(round_number, match_number, game_type) {
            if (game_type === GameType.ROUNDROBIN) {
                const filteredData = this.gameData.rounds.filter(item => item.type === 'Finals');

                if (filteredData[round_number-1] == null) return null;
                if (filteredData[round_number-1].matches[match_number-1] == null) return null;

                return filteredData[round_number-1].matches[match_number-1];
            }
            return null;           
        },
        toggleMatch(roundId, matchId, matchType, gameType, uniqueId) {
            //console.log("toggleMatch roundId: " + roundId + ", matchId: " + matchId + ", matchType: " + matchType + ", gameType: " + gameType + ", uniqueId: " + uniqueId);
            if (this.gameData.gameType ===  GameType.TOURNAMENT) {
                var sets = this.gameData.sets;
                for(var z = 0; z < sets.length; z++) {
                    var rounds = sets[z].rounds;
                    for(var x = 0; x < rounds.length; x++) {
                        var round = rounds[x];
                        for (var y = 0; y < round.matches.length; y++) {
                            var match = round.matches[y];
                            if (match.uniqueId === uniqueId) {
                                match.display = (match.display === true? false : true);
                                //if (match.display) {
                                //    var plyr = match.matchPlayers[0];
                                    //this.$parent.submitTickerItem(this.gameData, "NEW MATCH " + (y+1),'new_match', match);
                                    //this.$parent.submitTickerItem(this.gameData, "Now Throwing: " + plyr.player.name ,'now_throwing', plyr);
                                //}
                            }
                        }
                    }    
                }
                //this.forceRerender();
            } else {
                var rounds = (matchType === "Finals" ? this.getFinalRounds() : this.gameData.rounds);
                for(var x = 0; x < rounds.length; x++) {
                    var round = rounds[x];
                    for (var y = 0; y < round.matches.length; y++) {
                        var match = round.matches[y];
                        var matchIdString = roundId + (matchType === "Finals" ? "_Finals" : "") + "_" + matchId;
                        //console.log("matchIdString: " + matchIdString);
                        if (match.id === matchIdString) {
                            match.display = (match.display === true? false : true);
                            if (match.display) {
                                var plyr = match.matchPlayers[0];
                                //this.$parent.submitTickerItem(this.gameData, "NEW MATCH " + (y+1),'new_match', match);
                                //this.$parent.submitTickerItem(this.gameData, "Now Throwing: " + plyr.player.name ,'now_throwing', plyr);
                            }
                        }
                    }
                }
            }
        },
        displayTournamentMatch(nextMatch) {

            nextMatch.display = true;

            nextMatch.matchPlayers[0].throws[0].isActive = true;

            var m = {
                uniqueItemId: nextMatch.uniqueId,
                uniqueId: this.gameData.uniqueId,
                match: nextMatch,
                title: this.gameData.title,
                league: this.gameData.league,
                lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
            }

            this.sendBroadcastControlMessage('match', m, 'New Match','displayTournamentMatch');

            this.forceRerender();
        },
        displayMatch(roundId, matchId) {
            //console.log("displayMatch... roundId: " + roundId + ", matchId: " + matchId);
            for(var x = 0; x < this.gameData.rounds.length; x++) {
                var round = this.gameData.rounds[x];
                for (var y = 0; y < round.matches.length; y++) {
                    var match = round.matches[y];
                    //console.log("round.id: " + round.id);
                    //console.log("match.id: " + match.id);
                    var matchIdString = roundId + "_" + matchId;
                    //console.log("matchIdString: " + matchIdString);
                    if (match.id === matchIdString) {
                        //console.log("... display it");
                        match.display = true;

                        var m = {
                            uniqueItemId: match.uniqueId,
                            uniqueId: this.gameData.uniqueId,
                            match: match,
                            title: this.gameData.title,
                            league: this.gameData.league,
                            lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                        }
                        this.sendBroadcastControlMessage('match', m, 'New Match','displayMatch');

                    } else {
                        //console.log("... don't display it");
                        match.display = false;
                    }
                }
            }
        },
        populateUser: function(userIndex) {
            /*
            var players = this.gameData.players;
            players.splice(userIndex, 1);

            var player_uuid = uuidv4();

            //id, nickname, name, given_name, family_name, email, picture
            var p = new this.$playerClass(player_uuid, this.$auth.user.nickname, this.$auth.user.name, this.$auth.user.given_name, 
                this.$auth.user.family_name, this.$auth.user.email, this.$auth.picture);
            
            players.push(p);

            players.sort(this.sortById);

            this.gameData.players = players;
            //var player = this.gameData.players[userIndex];
            //player.name = this.$auth.user.name;
            //player.email = this.$auth.user.email;
            */
        },
        sortById: function(a, b) {
            if (a.id > b.id)
              return 1;
            if (a.id < b.id)
              return -1;
            return 0;
        },
        calculateThrowPoints: function (player) {
            var arr = [];
            if (this.gameData && this.gameData.rounds != null) {
                arr.push({label: '0', value: this.calculateAxeHit(player, this.gameData, 0)});
                arr.push({label: '1', value: this.calculateAxeHit(player, this.gameData, 1)});
                arr.push({label: '2', value: this.calculateAxeHit(player, this.gameData, 2)});
                arr.push({label: '3', value: this.calculateAxeHit(player, this.gameData, 3)});
                arr.push({label: '4', value: this.calculateAxeHit(player, this.gameData, 4)});
                arr.push({label: '5', value: this.calculateAxeHit(player, this.gameData, 5)});
            } else {
                arr.push({label: '0', value: 0});
                arr.push({label: '1', value: 0});
                arr.push({label: '2', value: 0});
                arr.push({label: '3', value: 0});
                arr.push({label: '4', value: 0});
                arr.push({label: '5', value: 0});
            }
            return arr;
        },
        calculateThrowsFinals: function(player, scorecard) {
            return this.$parent.calculateThrowsFinals(player, scorecard);
        },
        calculateAxeHit: function (player, scorecard, basicScore) {
            //console.log("calculateAxeHit - player id: " + player.id + ", basicScore: " + basicScore);
            var playerId = player.id;
            var total = 0;
            var basicScore = parseInt(basicScore);
            var rounds = 0;
            var throws = 0;
            var total_throws = 0;
            for(var x = 0; x < scorecard.rounds.length; x++) {
                var round = scorecard.rounds[x];
                //rounds = scorecard.rounds.length;
                if (round.title != "Practice") {
                    for (var y = 0; y < round.matches.length; y++) {
                        var match = round.matches[y];
                        for (var z = 0; z < match.matchPlayers.length; z++) {
                            var matchPlayer = match.matchPlayers[z];
                            var matchPlayerId = matchPlayer.id;
                            if (matchPlayerId == playerId) {
                                for (var a = 0; a < matchPlayer.throws.length; a++) {
                                    throws = matchPlayer.throws.length;
                                    var pThrow = matchPlayer.throws[a];
                                    var bScore = parseInt(pThrow.basicScore);
                                    if (bScore === basicScore) {
                                        total++;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            /*
            total_throws = rounds * throws;
            var avg = (total / total_throws)*100;
            var retStr = basicScore + ": " + total + " (" + avg.toFixed(0) + "%)";
            return retStr;
            */
           return total;
        },
        showAdModal() {
            this.isAdModalVisible = true;
        },
        showMoodModal() {
            this.isMoodModalVisible = true;
        },
        closeAdModal() {
            this.isAdModalVisible = false;
        },
        closeMoodModal() {
            this.isMoodModalVisible = false;
        },
        axeHit: function (event) {
            var pts = event.target.getAttribute("points");
            if (pts != null && pts != "") {
                this.points = parseInt(pts);
            }
        }, 
        playerName: function(matchPlayer) {
            var players = this.gameData.players;
            for (var i = 0; i < players.length; i++) {
                var player = players[i];
                if (player.id == matchPlayer.id) return player.name;
            }
            return "????";
        },
        allPlayersList: function() {
            return this.gameData.players;
        },
        /*
        addPlayer: function() {
            var id = (this.gameData.players != null && this.gameData.players.length +1);

            var player_uuid = uuidv4();

            //id, nickname, name, given_name, family_name, email, picture
            var p = new this.$playerClass(player_uuid, "", "", "", "", "", "");
            if (this.gameData.players == null) this.gameData.players = [];
            this.gameData.players.push(p);
        },*/
        removePlayer: function(player) {
            var newPlayerArray = new Array();
            for (var i = 0; i < this.gameData.players.length; i++) {
                if (player.id !== this.gameData.players[i].id) {
                    newPlayerArray.push(this.gameData.players[i]);
                }
            }
            this.gameData.players = newPlayerArray;
        },
        generateRound: function(type,roundNumber, roundTitle, numThrows) {
            //console.log("numThrows: " + numThrows);
            var matchesArr = new Array();
            
            var player = this.gameData.players[0];
            
            var matchPlayersArr = [];

            var throwsArr = new Array();
            for (var a = 0; a < numThrows; a++) {
                var playerThrow = new Axes2Throw(a+1);
                if (a === 0) playerThrow.isActive = true;
                throwsArr.push(playerThrow);
                //console.log("added player throw")
            }

            var matchPlayer = new Axes2MatchPlayer(1, throwsArr, player, false);

            matchPlayersArr.push(matchPlayer);

            var match = new Axes2Match(roundNumber+"_1", 0, matchPlayersArr);
            match.uniqueId = this.generateUniqueId();

            match.display =  true; //(roundNumber === 1 ? true : false);
            
            matchesArr.push(match);

            var round = new Axes2Round(roundNumber, 0, type, roundTitle, matchesArr);
            return round;
        },
        addRound: function(event) {
            //
            //
            var totalRounds = this.totalRounds();
            var nextRoundNumber = totalRounds+1;

            //console.log("adding round " + nextRoundNumber)
            //
            //
            //
            //
            alert("nope. doesn't work.");
            //
            //
        },
        buildSoloGame: function(event) {
            //number is matches is number of players
            var numRounds = this.rounds;
            var numMatches =  1;
            var numPlayers = 0;
            var numThrows = this.throws;
            var roundsArr = new Array();

            var counter = 1;

            //build rounds
            for (var x = 0; x < numRounds; x++) {
                var roundTitle = "Round "+(x+1);
                //console.log("build round: " + roundTitle);
                var round = this.generateRound(GameType.SOLO,counter,roundTitle,numThrows);
                round.uniqueId = this.generateUniqueId();

                counter++;
                roundsArr.push(round);
            }

            this.gameData.rounds = roundsArr;
            //console.log("done building solo game");

            this.saveGameInProgress(GameType.SOLO);
        }, 
        parseSchema: function(numRounds, numThrows, numPlayers, schema) {
            var parsedSchema = JSON.parse("{\"Brackets\":[{\"Players\": " + numPlayers + ",\"Rounds\":[],\"Finals\":{\"Type\": \"Hudson\",\"Rounds\":[]}}]}");
        
            for (var i = 0; i < schema.Brackets.length; i++) {
                var game = this.cloneAsObject(schema.Brackets[i]);
                if (game.Players === numPlayers) {
                    for (var x = 0; x < numRounds; x++) {
                        if ((x+1) <= parseInt(game.Rounds[x].Round)) {
                            var round = game.Rounds[x];
                            parsedSchema.Brackets[0].Rounds.push(round);
                        }
                    }
                    if (game.Finals != null) {
                        for (var x = 0; x < game.Finals.Rounds.length; x++) {
                            var round = game.Finals.Rounds[x];
                            var newRound = this.cloneAsObject(round);
                            newRound.Matches = [];
                            newRound.uniqueId = this.generateUniqueId();
                            newRound.originalRoundId = (x+1);
                            var matchCount = 0;
                            for (var y = 0; y < round.Matches.length; y++) {
                                var match = round.Matches[y];
                                match.uniqueId = this.generateUniqueId();
                                match.originalMatchId = (y+1); //or? match.Match;
                                if (match.player1 === "bye" || match.player2 === "bye") {
                                    //console.log("dropping match");
                                    //console.log(match);
                                } else {
                                    matchCount++;
                                    //match.Match = matchCount;
                                    //console.log("ADDING match");
                                    //console.log("match",match);
                                    newRound.Matches.push(match);
                                }
                            }
                            if (newRound.Matches.length != 0) {
                                parsedSchema.Brackets[0].Finals.Rounds.push(newRound)
                            }
                        }
                    }
                }
            }
            //console.log("parsedSchema:")
            //console.log(parsedSchema);
            return parsedSchema;
        },
        isNextRoundFinalsNeeded: function(currentRoundNumber, currentMatchNumber, nextRoundNumber, nextMatchNumber) {
            for (var i = 0; i < this.gameData.rounds.length; i++) {
                var round = this.gameData.rounds[i];
                var id = round.id.toString();
                if (id.indexOf("Final") != -1) {
                    let parts = id.split('_');
                    let currentRound = (parts[0] != null ? parts[0] : ""); //string?
                    if (Number(currentRound) === nextRoundNumber) {
                        for (var x = 0; x < round.matches.length; x++) {
                            var match = round.matches[x];
                            let match_id = match.id.toString();
                            let match_parts = match_id.split("_");
                            let currentMatch = (match_parts[2] != null ? match_parts[2] : "");
                            if (Number(currentMatch) === nextMatchNumber) {
                                console.log("isNextRoundFinalsNeeded NOT ADDING NEXT MATCH/ROUND")   
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        },        
        generateRoundRobinRounds: function(numRounds, numThrows, numPlayers, startingAt = 0) {

            var schema = this.parseSchema(numRounds, numThrows, numPlayers, this.axes2SchemaOriginal);

            //var schema = this.axes2Schema;
            var roundsArr = new Array();
            var rndCounter = 1;
            for (var i = 0; i < schema.Brackets.length; i++) {
                var game = schema.Brackets[i];
                if (game.Players === this.gameData.players.length) {
                    var rounds = game.Rounds;
                    for (var x = 0; x < rounds.length; x++) {

                        if (startingAt === 0 || x >= (startingAt-1)) {
                            
                            //console.log("generating round: " + (x+1))
                            
                            var round = rounds[x];
                            var roundNumber = x+1;
                            if (roundNumber <= numRounds) {
                                    
                                //console.log("ROUND: " + round.Round);

                                var rndMatches = [];

                                var matches = round.Matches;
                                for (var y = 0; y < matches.length; y++) {
                                    var matchNum = (y+1);
                                    var match = matches[y];
                                    
                                    //console.log("match",match);

                                    var player1Pos = parseInt(match.player1)-1;
                                    var player2Pos = parseInt(match.player2)-1;

                                    //console.log("player1Pos", player1Pos);
                                    //console.log("player2Pos", player2Pos);

                                    var bye = (match.bye === null ? null : match.bye);

                                    var throwsArr = new Array();
                                    var numThrows = this.throws;
                                    for (var a = 0; a < numThrows; a++) {
                                        var playerThrow = new Axes2Throw(a+1);
                                        //if (z === 0 && a === 0) playerThrow.isActive = true;
                                        throwsArr.push(playerThrow);
                                    }
                                    var throwsArr2 = this.cloneAsObject(throwsArr);

                                    if (throwsArr != null && throwsArr.length > 0) {
                                        //console.log("setting active throw")
                                        throwsArr[0].isActive = true;
                                    }

                                    var player1 = this.gameData.players[player1Pos];
                                    var player2 = this.gameData.players[player2Pos];
                                    /*
                                    //console.log("player 1");
                                    //console.log(player1);
                                    //console.log("player 2");
                                    //console.log(player2);
                                    */
                                    var players = [];
                                    var matchPlayer1 = new Axes2MatchPlayer(player1.id, throwsArr, player1, (bye === "player1" ? true : false));
                                    var matchPlayer2 = new Axes2MatchPlayer(player2.id, throwsArr2, player2, (bye === "player2" ? true : false));
                                    players.push(matchPlayer1);
                                    players.push(matchPlayer2);

                                    var mtch = new Axes2Match(rndCounter+"_"+(y+1), 0, players);
                                    mtch.uniqueId = this.generateUniqueId();

                                    //if (roundNumber === 1 && matchNum === 1)  mtch.display = true;
                                    //else mtch.display = false;
                                    mtch.display = false;

                                    rndMatches.push(mtch);
                                }

                                var round = new Axes2Round(rndCounter, 0, GameType.ROUNDROBIN, 'Round ' + rndCounter, rndMatches);
                                round.uniqueId = this.generateUniqueId();

                                roundsArr.push(round);

                            }
                        }
                        rndCounter++;
                    }
                }
            }
            return roundsArr;
        },
        buildTournament: function() {

            //var ticker_uuid = uuidv4();
            //this.gameData.ticker_uuid = ticker_uuid;
            this.gameData.uniqueId = this.generateUniqueId();

            //this.$parent.submitTickerItem(this.gameData, "NEW TOURNAMENT: " + this.gameData.title, 'new_game');

            //same code used in addNextTournamentFinals
            var setsArr = this.generateTournament(false);

            if (setsArr != null) {
                this.gameData.sets = setsArr;
            }

            //console.log("generateTournament returned:");
            //console.log(setsArr);
            //end
            var players = {
                uniqueItemId: this.generateUniqueId(),
                uniqueId: this.gameData.uniqueId,
                players: this.gameData.players,
                title: this.gameData.title,
                league: this.gameData.league,
                lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
            }

            //broadcast to display
            //console.log("send new_game broadcast control message");
            this.sendBroadcastControlMessage('new_game', players, 'New Game','buildTournament');

            this.refreshKey = this.generateUniqueId();


            //broadcast to display
            var m = {
                uniqueItemId: this.gameData.sets[0].rounds[0].matches[0].uniqueId,
                uniqueId: this.gameData.uniqueId,
                match: this.gameData.sets[0].rounds[0].matches[0],
                title: this.gameData.title,
                league: this.gameData.league,
                lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
            }
            //console.log("sending new match broadcast control message", m);
            this.sendBroadcastControlMessage('match', m, 'New Match','buildTournament');

            //open first match
            //TODO tournament next step
            //this.toggleMatch("", "", "", "", this.gameData.sets[0].rounds[0].matches[0].uniqueId);
            //
            //
            //
            //
            this.showPlayerManagement = true;
            //
            //
            //
            //
            this.saveGameInProgress( GameType.TOURNAMENT);
            
            //set first throw
            this.gameData.sets[0].rounds[0].matches[0].matchPlayers[0].throws[0].isActive = true;

            //var jsonStringDev = JSON.stringify(this.gameData);
            //console.log(jsonStringDev)
        },
        generateTournament: function(isFinals) {
            //console.log("generateTournament",isFinals);

            var numSets = this.sets;
            var numRounds = this.rounds;
            var numThrows = this.throws;
            var numTargets = this.targets;

            var playersWithNames = [];
            if (isFinals){
                for (var j = 0; j < this.gameData.finalPlayers.length; j++) {
                    var p = this.gameData.finalPlayers[j];
                    if(p.name != "") {
                        playersWithNames.push(p);
                    }
                }
            } else {
                for (var j = 0; j < this.gameData.players.length; j++) {
                    var p = this.gameData.players[j];
                    if(p.name != "") {
                        playersWithNames.push(p);
                    }
                }
            }
            var numPlayers = playersWithNames.length;

            //var output_string2 = "";
            var output_string = "";
            output_string += "\n******************************************************";
            output_string += "\nSets " + numSets;
            output_string += "\nRounds " + numRounds;
            var numMatches = Math.ceil(numPlayers / numTargets);
            output_string += "\nPlayers " + numPlayers;
            output_string += "\nTargets " + numTargets;
            output_string += "\nMatches " + numMatches;
            output_string += "\nThrows " + numThrows;
            output_string += "\n******************************************************";

            var tournySets = [];

            var firstMatch = true;
            var counter = (isFinals ? 1000 : 0);
            
            for(var i = 0; i < numSets; i++) {

                output_string += "\nSet: " + (i+1);
                //output_string2 += "\nS" + (i+1);

                var tournyRounds = [];

                //for how ever many numplayers/targets
                for(var x = 0; x < numMatches; x++) {

                    for (var y = 0; y < numRounds; y++) {

                        var tournyMatches = [];

                        var round_num = (y+1);
                        if (i > 0) {
                            round_num += (numRounds * i);
                        }
                        output_string += "\n    Round: " + round_num;
                        //output_string2 += "\n   R" + round_num;

                        var match_num = x+1;
                        output_string += "\n        Match: " + match_num;
                        //output_string2 += " M" + match_num;

                        //var players = this.cloneAsObject((isFinals ? this.gameData.finalPlayers : this.gameData.players));
                        var players = this.cloneAsObject(playersWithNames);

                        //if match > 0
                        if (x > 0) {
                            //how many players to remove?
                            var p = x * numTargets;
                            for (var t = 0; t < p; t++) {
                                players.shift();
                            }
                        }

                        var tournyPlayers = []
                        for (var z = 0; z < numTargets; z++) {
                            var player = players.shift();
                            if (player != null) {
                                output_string += "\n            " + player.name + "\n               ";
                                var tournyThrows = [];
                                for(var a = 0; a < numThrows; a++) {
                                    output_string += " throw "+ (a+1);
                                    tournyThrows.push(new Axes2Throw(a+1))
                                }
                                var matchPlayer = new Axes2MatchPlayer(z+1, tournyThrows, player, false);
                                tournyPlayers.push(matchPlayer);
                            }
                        }
                        var match = new Axes2Match(match_num, 0, tournyPlayers) 
                        match.uniqueId = this.generateUniqueId();

                        counter++;
                        if (firstMatch) {
                            firstMatch = false;
                        }

                        if (isFinals) match.type = "Finals";
                        else match.type = "Regular";

                        tournyMatches.push(match);

                        var round = new  Axes2Round(round_num, 0,  GameType.TOURNAMENT, 'Round ' + round_num, tournyMatches); 
                        round.uniqueId = this.generateUniqueId();
                        if (isFinals) round.type = 'Finals';

                        tournyRounds.push(round);

                    }
                }
                var tournySet = new Axes2Set((i+1),tournyRounds);
                tournySet.uniqueId = this.generateUniqueId();

                tournySets.push(tournySet);
                //setCount++;
            }
            //console.log(output_string);
            //console.log(output_string2);
                        
            return tournySets;
        },
        buildRoundRobinGame: function(event) {
            var numRounds = this.rounds;
            var numThrows = this.throws;
            var numPlayers = this.gameData.players.length;

            this.axes2Schema = this.parseSchema(numRounds, numThrows, numPlayers, this.axes2SchemaOriginal);

            var roundsArr = this.generateRoundRobinRounds(numRounds, numThrows, numPlayers);

            this.gameData.uniqueId = this.generateUniqueId();

            this.gameData.rounds = roundsArr;

            this.showPlayerManagement = true;

            var ticker_uuid = uuidv4();
            this.gameData.ticker_uuid = ticker_uuid;

            var players = {
                uniqueItemId: this.generateUniqueId(),
                uniqueId: this.gameData.uniqueId,
                players: this.gameData.players,
                title: this.gameData.title,
                league: this.gameData.league,
                lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
            }

            this.sendBroadcastControlMessage('new_game', players, 'New Round-Robin','buildRoundRobinGame');

            this.saveGameInProgress(GameType.ROUNDROBIN);
            /*
            var m = {
                uniqueItemId: this.gameData.rounds[0].matches[0].uniqueId,
                uniqueId: this.gameData.uniqueId,
                match: this.gameData.rounds[0].matches[0],
                title: this.gameData.title,
                league: this.gameData.league
            }
            this.sendBroadcastControlMessage('match', JSON.stringify(m), 'New Match');
            */
            //console.log("GAME SETUP!");
            //console.log(this.gameData);
        },
        validatePlayers() {
            var playersValid = true;

            if (this.gameData.gameType === GameType.SOLO) {
                var users = [];

                //var player_uuid = uuidv4();

                //id, nickname, name, given_name, family_name, email, picture
                var p = new this.$playerClass(1, this.$auth.user.nickname, this.$auth.user.name, this.$auth.user.given_name, 
                    this.$auth.user.family_name, this.$auth.user.email, this.$auth.picture);
                users.push(p);

                this.gameData.players = users;

            } else if (this.gameData.gameType === GameType.ROUNDROBIN) {

                var addPlayers = [];
                var players = this.cloneAsObject(this.gameData.players);
                players.forEach(player => {
                    if (player.name != '') {
                        addPlayers.push(player);
                    }
                })

                this.gameData.players = null;
                this.gameData.players = addPlayers;

                if (addPlayers.length === 0) playersValid = false;
            }
            return playersValid;
        },
        showConfidenceMessage: function() {
            var sayingsArray = ["You've got this", "Trust your training.", "Stay focused, stay calm.", "Just breathe and do your thing.","All your hard work leads to this.", "One step at a time.", "Let your instincts take over.", "You're ready for this.",  "Believe in yourself.", "Go out there and enjoy it." ];

            var r = Math.ceil(Math.random() * sayingsArray.length); 

            var saying = sayingsArray[r];

            this.$toast.open({
                message: saying,
                type: "success",
                duration: 5000,
                dismissible: true,
                position: "top-right",
            });
        },
        buildGame: function(event) {

            if (this.gameData.gameType == GameType.SOLO) {
                this.showConfidenceMessage();
            }

            this.scorecardSubmitted = false;
            this.gameData.gameComplete = false;

            var validTitle = ((this.gameData.gameType == GameType.ROUNDROBIN || this.gameData.gameType ==  GameType.TOURNAMENT) && this.gameData.title == "" ? false : true);
            if (!validTitle) {
                alert("Title is a required field."); 
                return;
            }

            if (this.validatePlayers()) {

                //set location on the game
                var loc = this.$store.getters.getLocation;
                var location_json_str = JSON.stringify(this.cloneAsObject(loc)); 
                var location_json = JSON.parse(location_json_str);
                this.gameData.location = location_json;
                this.isStarted = true;

                //set weather on the game.
                this.gameData.weather = this.weather;

                var now = new Date;
                var utc_timestamp = Date.UTC(now.getUTCFullYear(),now.getUTCMonth(), now.getUTCDate() , 
                    now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());

                this.gameData.dateTimeStamp = new Date(utc_timestamp).toISOString();

                this.gameData.subscriber = this.$auth.user.email;
                this.gameData.subscriberProfile = this.profile;

                this.gameData.liveLoggingEnabled = this.liveLoggingEnabled;

                if (this.gameData.gameType === GameType.SOLO) {
                    this.gameData.league = '';
                    if (this.profile.axe === 'Other') {
                        this.gameData.axe = this.profile.axe_other;
                    } else {
                        this.gameData.axe = this.profile.axe;
                    }
                    if (this.profile.country != null) {
                        this.gameData.country = this.profile.country;
                    }
                    this.buildSoloGame();
                } else if (this.gameData.gameType === GameType.ROUNDROBIN) {
                    this.gameData.league = this.league;
                    this.gameData.axe = '';
                    this.gameData.country = '';
                    this.buildRoundRobinGame();
                } else if (this.gameData.gameType ===  GameType.TOURNAMENT) {
                    this.gameData.league = this.league;
                    this.gameData.axe = '';
                    this.gameData.country = '';
                    //TODO
                    //console.log("tournament", this.gameData);
                    //
                    this.buildTournament();
                }

                //scroll top
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            } else {
                alert("Players need names.");
            }
        },
        cloneAsObject: function(obj) {
            if (obj === null || !(obj instanceof Object)) {
                return obj;
            }
            var temp = (obj instanceof Array) ? [] : {};
            // ReSharper disable once MissingHasOwnPropertyInForeach
            for (var key in obj) {
                temp[key] = this.cloneAsObject(obj[key]);
            }
            return temp;
        },
        buildSoloFinals: function() {
            //
            //
        },
        findFinalRoundMatchWinner: function(roundNum, matchNum) {
            console.log("findFinalRoundMatchWinner: roundNum " + roundNum + ", matchNum: " + matchNum);
            if (this.gameData.rounds != null) {
                for (var a = 0; a < this.gameData.rounds.length; a++) {
                    var rnd = this.gameData.rounds[a];
                    if (rnd.type === "Finals") {
                        if (roundNum === rnd.originalRoundId) {
                            for (var b = 0; b < rnd.matches.length; b++) {
                                var mtch = rnd.matches[b];
                                if (matchNum === mtch.originalMatchId) {
                                    console.log("mtch.winnerId", mtch.winnerId);
                                    return (mtch.winnerId);
                                }
                            }
                        }
                    }
                }
            }
            return null;
        },
        addNextTournamentFinals: function() {

            var countFinals = this.countFinalSets();
            var isFinals = true;
            var setsArr = this.generateTournament(isFinals);

            var firstMatchUniqueId = "";
            var firstMatch = null;
            for (var x = 0; x < setsArr.length; x++) {
                setsArr[x].type = 'Finals';
                countFinals++;
                setsArr[x].id = countFinals;
                if (x === 0) {
                    //set first throw
                    firstMatch = setsArr[x].rounds[0].matches[0];
                    setsArr[x].rounds[0].matches[0].matchPlayers[0].throws[0].isActive = true;
                    firstMatchUniqueId = setsArr[x].rounds[0].matches[0].uniqueId;
                }
                this.gameData.sets.push(setsArr[x]);
            }

            this.refreshKey = this.generateUniqueId();

            //open first match
            this.toggleMatch("", "", "", "", firstMatchUniqueId);

            //broadcast to display
            var m = {
                uniqueItemId: firstMatch.uniqueId,
                uniqueId: this.gameData.uniqueId,
                match: firstMatch,
                title: this.gameData.title,
                league: this.gameData.league,
                lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
            }

            this.sendBroadcastControlMessage('match', m, 'New Match','addNextTournamentFinals');
        },
        getFirstAndLastUppercase: function(str) {
            if (str.length < 2) {
                return str.toUpperCase(); // If the string is too short, just return it in uppercase
            }
            const firstLetter = str.charAt(0).toUpperCase();
            const lastLetter = str.charAt(str.length - 1).toUpperCase();
            return firstLetter + lastLetter;
        },        
        //this function is called by buildFinals and openNextMatch
        addNextRoundRobinFinals: function(currentRoundNumber, currentMatchNumber, nextRoundNumber, nextMatchNumber) {
            if (currentRoundNumber != nextRoundNumber) {
                this.addNewEliminationRound(nextRoundNumber);  
                this.addNewEliminationMatchToRound(nextRoundNumber, nextMatchNumber);
            } else {
                this.addNewEliminationMatchToRound(nextRoundNumber, nextMatchNumber);
            }
        },
        addNewEliminationRound: function(rndNumber) {
            var schema = this.getEliminationRoundSchema(rndNumber);
            var originalRoundId = schema.Round;
            var round = new Axes2Round(rndNumber + "_Finals", originalRoundId, 'Finals', schema.Title, []);
            this.gameData.rounds.push(round);
        },
        getEliminationRoundSchema: function(roundNum) {
            //console.log("getEliminationRoundSchema roundNum: " + roundNum);
            var roundSchema = null;
            var schema = this.axes2SchemaOriginal;

            var numRounds = this.rounds;
            var numThrows = this.throws;
            var numPlayers = this.gameData.finalPlayers.length;

            schema = this.parseSchema(numRounds, numThrows, numPlayers, schema)

            var numPlayers = this.gameData.finalPlayers.length; //finalPlayers list
            for (var i = 0; i < schema.Brackets.length; i++) {
                var game = schema.Brackets[i];
                if (game.Players === numPlayers) {
                    var finals = game.Finals;
                    var rounds = finals.Rounds;
                    roundSchema = rounds[roundNum-1];
                }
            }
            //console.log("Round " + roundNum + " Schema:");
            //console.log(roundSchema);
            return roundSchema;
        },
        getEliminationRoundMatchSchema: function(roundNum, matchNum) {
            //console.log("getEliminationRoundMatchSchema roundNum: " + roundNum + ", matchNum: " + matchNum);
            var roundSchema = this.getEliminationRoundSchema(roundNum);
            var matchSchema = null;

            var matches = roundSchema.Matches;
            //console.log("... matches: " + matches.length);
            var matchCounter = 1;
            for (var y = 0; y < matches.length; y++) {
                if (matchCounter === matchNum) {
                    var match = matches[y];
                    matchSchema = match;
                }
                matchCounter++;
            }
            //console.log(matchSchema);
            return matchSchema;
        },
        addNewEliminationMatchToRound: function(roundNum, matchNum) {
            //console.log("addNewEliminationMatchToRound roundNum: " + roundNum + ", matchNum: " + matchNum);
            //
            //
            var rnds = this.getFinalRounds();
            if (rnds != null) {

                var rnd = rnds[roundNum-1];
                if (rnd != null) {
                
                    //console.log("last final round: " + rnd.title);
                    //console.log(rnd);

                    var matchSchema = this.getEliminationRoundMatchSchema(roundNum, matchNum);
                    //console.log("getEliminationRoundMatchSchema");
                    //console.log(matchSchema);

                    if (matchSchema) {
                        //console.log("  Match Schema: ");
                        //console.log(matchSchema);
                        //console.log("    player1: " + matchSchema.player1);
                        //console.log("    player2: " + matchSchema.player2);

                        var player1 = null;
                        if (isNaN(matchSchema.player1)) {
                            //console.log("determine winner " + matchSchema.player1);
                            //alert("dynamic player 1: " + matchSchema.player1)
                            //console.log("**** dynamic player 1: " + matchSchema.player1)

                            if (matchSchema.player1 === "bye") {
                                //
                                //console.log("(bye) getRandomFinalsPlayer")
                                player1 = [];
                                //
                                //
                            } else {
                                var strArr = matchSchema.player1.split("");
                                var roundStr = strArr[1];
                                var matchStr = strArr[3];

                                var rNum = parseInt(roundStr);
                                var mNum = parseInt(matchStr);

                                //console.log("find winner of match and round", rNum, mNum);

                                //find winner
                                var prevWinnerId = this.findFinalRoundMatchWinner(rNum, mNum);
                                for (var x = 0; x < this.gameData.finalPlayers.length; x++) {
                                    var p = this.gameData.finalPlayers[x];
                                    if (p.id === prevWinnerId) {
                                        player1 = p;
                                    }
                                }
                                //console.log(" player1 prevWinner", player1);
                            }
                        } else {
                            var player1Pos = parseInt(matchSchema.player1)-1;
                            player1 = this.gameData.finalPlayers[player1Pos];

                            //console.log(" player1:");
                            //console.log(player1);
                        }

                        var player2 = null;
                        if (isNaN(matchSchema.player2)) {

                            if (matchSchema.player2 === "bye") {
                                player2 = [];
                            } else {
                                var strArr = matchSchema.player2.split("");
                                var roundStr = strArr[1];
                                var matchStr = strArr[3];

                                var rNum = parseInt(roundStr);
                                var mNum = parseInt(matchStr);

                                //find winner
                                var prevWinnerId = this.findFinalRoundMatchWinner(rNum, mNum);
                                for (var x = 0; x < this.gameData.finalPlayers.length; x++) {
                                    var p = this.gameData.finalPlayers[x];
                                    if (p.id === prevWinnerId) {
                                        player2 = p;
                                    }
                                }
                            }
                        } else {
                            var player2Pos = parseInt(matchSchema.player2)-1;
                            player2 = this.gameData.finalPlayers[player2Pos];

                            //console.log(" player2:");
                            //console.log(player2);
                        }

                        var throwsArr = this.cloneAsObject(this.buildThrowsArray());

                        var plyrsArr = [];

                        var matchPlayer1 = new Axes2MatchPlayer("",[],[], false);
                        if (matchSchema.player1 !== "bye") {
                            var thrws = throwsArr[0];
                            if (matchSchema.player2 === "bye") thrws = [];
                            matchPlayer1 = new Axes2MatchPlayer(player1.id, thrws, player1, false);
                        } else {
                            matchPlayer1.bye = true;
                        }
                        plyrsArr.push(matchPlayer1);

                        var matchPlayer2 = new Axes2MatchPlayer("",[],[], false);
                        if (matchSchema.player2 !== "bye") {
                            var thrws = throwsArr[1];
                            if (matchSchema.player1 === "bye") thrws = [];
                            matchPlayer2 = new Axes2MatchPlayer(player2.id, thrws, player2, false);
                        } else {
                            matchPlayer2.bye = true;
                        }
                        plyrsArr.push(matchPlayer2);
                        
                        var nextMatchNum = (matchNum);
                        var mtch = new Axes2Match(roundNum + "_Finals_" + nextMatchNum, matchSchema.Match, plyrsArr);

                        //mtch.display = (matchSchema.player1 === "bye" && matchSchema.player2 === "bye" ? false : true);
                        mtch.display = true;

                        //console.log("  add MATCH " + nextMatchNum + " to ROUND " + roundNum);
                        rnd.matches.push(mtch);

                        var plyr = mtch.matchPlayers[0];
                        //this.$parent.submitTickerItem(this.gameData, "NEW MATCH (Finals)",'new_match', mtch);
                        //this.$parent.submitTickerItem(this.gameData, "Now Throwing: " + plyr.player.name ,'now_throwing', plyr);
                        
                    }
                }
            } else {
                //console.log(" final rounds is null");
            }
        },
        getRandomFinalsPlayer: function() {
            //console.log("getRandomFinalPlayer");
            var plyrs = this.gameData.finalPlayers;
            var maxNum = plyrs.length;
            var randomNum = Math.floor(Math.random() * maxNum);
            var randomFinalPlayer = this.gameData.finalPlayers[randomNum];
            randomFinalPlayer.bye = true;
            //console.log(randomFinalPlayer);
            return (randomFinalPlayer);
        },
        buildThrowsArray: function() {
            var throwsArr = new Array();
            var numThrows = this.throws;
            for (var a = 0; a < numThrows; a++) {
                var playerThrow = new Axes2Throw(a+1);
                //if (z === 0 && a === 0) playerThrow.isActive = true;
                throwsArr.push(playerThrow);
            }
            var throwsArr2 = this.cloneAsObject(throwsArr);

            if (throwsArr != null && throwsArr.length > 0) {
                //console.log("setting active throw")
                throwsArr[0].isActive = true;
            }
            var thrws = [];
            thrws.push(throwsArr);
            thrws.push(throwsArr2);
            return thrws;
        },
        checkTournamentMatchesCompleted: function() {
            for(var z = 0; z < this.gameData.sets; z++) {
                for(var i = 0; i < this.gameData.sets[z].rounds.length; i++) {
                    var rnd = this.gameData.sets[z].rounds[i];
                    for (var x = 0; x < rnd.matches.length; x++) {
                        var mtch = rnd.matches[x];
                        if (!mtch.completed) return false;
                    }
                }
            }
            return true;
        },
        markAllTournamentMatchesCompleted: function() {
            for(var z = 0; z < this.gameData.sets; z++) {
                for(var i = 0; i < this.gameData.sets[z].rounds.length; i++) {
                    var rnd = this.gameData.sets[z].rounds[i];
                    for (var x = 0; x < rnd.matches.length; x++) {
                        var mtch = rnd.matches[x];
                        mtch.completed = true;
                    }
                }
            }
        },
        markAllRoundRobinMatchesCompleted: function() {
            for(var i = 0; i < this.gameData.rounds.length; i++) {
                var rnd = this.gameData.rounds[i];
                if (rnd.type === "Round-Robin") {
                    for (var x = 0; x < rnd.matches.length; x++) {
                        var mtch = rnd.matches[x];
                        mtch.completed = true;
                    }
                }
            }
        },
        buildFinalPlayersList: function() {
            //console.log("buildFinalPlayersList()");
            var selectedPlyrs = [];
            var plyrs = (this.sortFinalPlayers === 'avg' ? this.playersSortedByAverage : this.gameData.players);
            for(var x = 0; x < plyrs.length; x++) {
                var plyr = plyrs[x];
                if (plyr.selectedForFinals === true) {
                    selectedPlyrs.push(plyr);
                }
            }
            if (selectedPlyrs.length > 1) {
                //console.log(selectedPlyrs);
                this.gameData.finalPlayers = selectedPlyrs;
            }
            //alert("adding " + selectedPlyrs.length + " players");
        },
        buildFinals: function(event) {

            if (this.gameData.gameType ===  GameType.TOURNAMENT) {

                this.markAllTournamentMatchesCompleted();

                this.buildFinalPlayersList();

                if (this.gameData.finalPlayers == null || this.gameData.finalPlayers.length < 2) {
                    alert("You must select at least two players.");
                    return;
                }

                this.showFinalsPlayerSelection = false;

                this.addNextTournamentFinals();

                this.saveGameInProgress( GameType.TOURNAMENT);

            } else if (this.gameData.gameType === GameType.ROUNDROBIN) {
                
                //this.$parent.submitTickerItem(this.gameData, "FINALS", 'finals_started');

                //console.log("marking all round-robin rounds as completed");
                this.markAllRoundRobinMatchesCompleted();

                if (this.gameData.finalPlayers === null || this.gameData.finalPlayers.length === 0) {

                    //console.log("## building final player list")
                    this.buildFinalPlayersList();

                    if (this.gameData.finalPlayers.length > 1) {

                        //get next round and match number
                        var currentRoundNumber = 0;
                        var currentMatchNumber = 0;
                        var isFinals = true;
                        var nextString = this.getNext(isFinals, currentRoundNumber, currentMatchNumber);
                        var nextArr = nextString.split("_");
                        var nextRoundNumber = parseInt(nextArr[0]);
                        var nextMatchNumber = parseInt(nextArr[1]);

                        this.addNextRoundRobinFinals(currentRoundNumber, currentMatchNumber, nextRoundNumber, nextMatchNumber);

                        var next_match = this.getFinalsMatch(nextRoundNumber, nextMatchNumber, GameType.ROUNDROBIN);

                        //broadcast to display
                        var m = {
                            uniqueItemId: next_match.uniqueId,
                            uniqueId: this.gameData.uniqueId,
                            match: next_match,
                            title: this.gameData.title,
                            league: this.gameData.league,
                            lane_id: (this.gameData?.lane_id ? this.getFirstAndLastUppercase(this.gameData.lane_id) : "")
                        }

                        this.sendBroadcastControlMessage('match', m, 'New Match','buildFinals');

                    } else {
                        alert("You must select at least two players.");
                    }
                }

                this.saveGameInProgress(GameType.ROUNDROBIN);
            }
        },
        finalTitle: function(roundNum, totalNum) {
            roundNum++;
            //console.log("final title... roundNum: " + roundNum + " totalNum: " + totalNum);
            if (totalNum === 3) {
                if (roundNum === 1) {
                    return "Quarter-Final";
                } else if (roundNum === 2) {
                    return "Semi-Final";
                } else if (roundNum === 3) {
                    return "Final";
                }
            } else if (totalNum === 2) {
                if (roundNum === 2) {
                    return "Semi-Final";
                } else if (roundNum === 1) {
                    return "Final";
                }
            } else if (totalNum === 1) {
                return "Final";
            }
            return "Final " + roundNum;
        },
        printScoreCard: function(event) {
            window.print();
        },
        resetScoreCard: function(event) {
            if (confirm("Reset Scorecard?")) {
                this.doResetScoreCard();
            }
        },
        doResetScoreCard: function(event) {
            this.isStarted = false;
            this.gameData.gameType = "Solo";
            this.gameData.uniqueId = "";
            this.gameData.title = "";
            this.gameData.rounds = [];
            this.gameData.sets = [];
            this.gameData.players = [
                { id: 1, name: "", email: ""}, 
                { id: 2, name: "", email: ""},
                { id: 3, name: "", email: ""},
                { id: 4, name: "", email: ""},
                { id: 5, name: "", email: ""},
                { id: 6, name: "", email: ""},
                { id: 7, name: "", email: ""},
                { id: 8, name: "", email: ""},
                { id: 9, name: "", email: ""},
                { id: 10, name: "", email: ""},
                { id: 11, name: "", email: ""},
                { id: 12, name: "", email: ""},
                { id: 13, name: "", email: ""},
                { id: 14, name: "", email: ""},
                { id: 15, name: "", email: ""},
                { id: 16, name: "", email: ""},
                { id: 17, name: "", email: ""},
                { id: 18, name: "", email: ""},
                { id: 19, name: "", email: ""},
                { id: 20, name: "", email: ""}
            ];
            this.gameData.finalPlayers = [];
            this.gameData.league = "";
            this.gameData.axe = "";
            this.gameData.mood =  { "feel": "", "changedText": "", "focusText": "" };
            this.roundsLocked = false;
            this.finalsLocked = false;
            this.rounds = 6;
            this.throws = 6;
            this.sets = 3;
            this.targets = 6;
            this.league = "";
            this.axe = "";
            this.showFinalsPlayerSelection = false;
            this.showPlayerManagement = false;
            this.nextRoundNumber = 0;
            this.componentKey = 0;
            this.refreshKey = 0;
        },
        submitMood() {
            //alert("submit....");
            //this should call
            this.closeMoodModal();
            this.showAdModal();
        },
        submitScoreCard: function(event) {
            //if (this.gameData.gameType == "Solo") {
            //    this.showMoodModal();
            //} else {
                this.showAdModal();
            //}
        },
        submitGameToDatabase: function(event) {
            this.closeAdModal();
            var jsonString = JSON.stringify(this.gameData);
            var token = this.$parent.getApiToken();
            var url = (this.debugMode ? "http://localhost:8080/scorecard" : "https://axes2api.azurewebsites.net/scorecard");
            axios(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'authorization': token
                },
                data: jsonString,
            })
            .then(response => {
                //console.log(response.data);

                this.scorecardSubmitted = true;
                window.removeEventListener("beforeunload",handleRefresh, true);

                this.doResetScoreCard();

                router.push('home');                
            })
            .catch(error => {
                alert(error);
            });
        },
        saveGameInLocalStorage: function(final_submit) {
            if (this.isLocalStorageEnabled()) {
                var gameData = JSON.stringify(this.gameData);
                //console.log("saveGameInLocalStorage", this.gameData);
                localStorage.setItem("game_"+this.gameData.Guid, gameData);
            }
        },
        resumeGameFromLocalStorage(gm) {
            this.gameData = gm;
            this.isStarted = true;
            if (this.gameData.gameType == "Tournament") {
                var countFinals = this.countFinalSets();
                var matchesCompleted = this.checkTournamentMatchesCompleted();
                //but only if matches completed
                if (countFinals == 0 && matchesCompleted) {
                    this.showFinalsPlayerSelection = true;
                }
            }
        },
        deleteGameFromLocalStorage: function(gm) {
            //delete the game from local storage (cache)
            if (this.isLocalStorageEnabled()) {
                var guid = gm.Guid;
                //console.log("deleteGameFromLocalStorage", guid);
                localStorage.removeItem("game_"+guid);
                this.getLocalStorage();
            }
        },
        doSubmitScoreCard: function(event) {
            //delete the game from local storage (cache)
            if (this.isLocalStorageEnabled()) {
                this.deleteGameFromLocalStorage(this.gameData);
            }
            this.closeAdModal();
            this.submitGameToDatabase()
        },
        saveGameInProgress(game_type) {
            console.log("saveGameInProgress " + game_type);
            if (this.gameData.Guid == null) {
                var guid = this.generateUniqueId();
                //console.log("Guid", guid);
                this.gameData.Guid = guid;
            } 
            this.saveGameInLocalStorage();
        },
        isLocalStorageEnabled() {
            try {
                const key = `__storage__test`;
                window.localStorage.setItem(key, null);
                window.localStorage.removeItem(key);
                return true;
            } catch (e) {
                return false;
            }
        },
        shiftArrayToRight: function(arr, places) {
            for (var i = 0; i < places; i++) {
                arr.unshift(arr.pop());
            }
            return arr;
        },
        checkSubscription: function() {

            if (this.$auth.isSubscribed) {
                this.isSubscribed = true;
                this.subscriptionChecked = true;
                return true;
            }

            var token = this.$parent.getApiToken();
            var url = (this.debugMode ? "http://localhost:8080/subscription?email=" : "https://axes2api.azurewebsites.net/subscription?email=");
            axios.get(url + this.$auth.user.email,{
                    headers: {
                        authorization: token
                    }
                })
                .then((response) => {
                    if (response.data.error != null) {
                        //
                        alert("Error checking for subscription.\n\n" + response.data.error.toString())
                        this.subscriptionChecked = true;
                        //
                    } else if (response.data.length == 0) {
                        //
                        //alert("No subscription found.")
                        this.subscriptionChecked = true;
                        //
                    } else {
                        //alert("Subscription found!");
                        this.isSubscribed = true;
                        this.subscriptionChecked = true;
                        this.subscriptionId = response.data[0].subscriptionId;

                        this.$auth.isSubscribed = true;

                        setTimeout(() => {
                            this.isLoading = false
                        }, 3000)

                    }
                }, (error) => {
                    alert("Error checking for subscription.\n\n" + error.toString())
                    this.subscriptionChecked = true;
                });
        },
        getWeather() {
            //console.log("get weather");
            var loc = this.$store.getters.getLocation;
            if (loc == null) {
                //console.log("... location not available.");
            } else {
                //console.log("location:")
                //console.log(loc);
                var token = this.$parent.getApiToken();
                var url = (this.debugMode ? "http://localhost:8080/weather" : "https://axes2api.azurewebsites.net/weather")
                url += "/" + loc.coords.latitude + "/" + loc.coords.longitude;
                //console.log(url);
                axios.get(url, {
                    headers: {
                        authorization: token
                    }
                })
                .then((response) => {
                    this.weather = response.data;
                }, (error) => {
                    console.log(error);
                });
            }
        },
        removeWeather() {
            this.weather = null;
            this.gameData.weather = this.weather;
        },
        getProfile() {
            //console.log("get profile")
            var token = this.$parent.getApiToken();
            var url = (this.debugMode ? "http://localhost:8080/profile" : "https://axes2api.azurewebsites.net/profile")
            url += "/" + this.$auth.user.email;
            axios.get(url, {
                headers: {
                    authorization: token
                }
            })
            .then((response) => {
                //console.log(response.data)
                //hack
                response.data.club = response.data.club.toUpperCase();
                this.profile = response.data;
            }, (error) => {
                console.log(error);
            });
        },
        getLocalStorage() {
            if (this.isLocalStorageEnabled()) {

                this.savedGamesInProgress = [];
                //console.log("Checking local storage for incomplete games:")
            
                for(var i=0, len=localStorage.length; i<len; i++) {
                    var key = localStorage.key(i);
                    var value = localStorage[key];
                    //console.log(key + " => " + value);

                    //console.log("adding incomplete game to savedGamesInProgress array...");
                    if (key.indexOf("game") === 0) {
                        var gameData = JSON.parse(value);
                        //console.log(gameData.Guid)
                        this.savedGamesInProgress.push(gameData);
                    }
                }
            }
        }
    },
    beforeMount() {

    },
    mounted(){
       if (!this.isSubscribed && !this.subscriptionChecked) {
            this.checkSubscription();
        } else {
            //alert("subscription alredy checked");
        }
        this.getAxes2Schema();
        this.getProfile();
        this.getWeather();

        //this.getAxeList();
        var dateFormat = require('dateformat');
        this.dateDisplay = dateFormat(new Date(), "mm/dd/yyyy");

        //check for any incomplete games.
        this.getLocalStorage();
    }
}

//handle page refresh with confirmation message ("Reload site?  Changes you made may not be saved.")
window.addEventListener("beforeunload", handleRefresh);

function handleRefresh(e) {
  var confirmationMessage = "\o/";
  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;  
}


function Axes2Profile(id, nickname, name, given_name, family_name, email, picture, country, axe) {
	this._id = id;
  this.nickname = nickname;
  this.name = name;
  this.given_name = given_name;
  this.family_name = family_name;
  this.email = email;
  this.picture = picture;
  this.country = country;
  this.axe = axe;
}

function Axes2Tourny(id, title, rounds, players) {
	this.id = id;
  	this.title = title;
	this.rounds = rounds;
	this.players = players;
}
function Axes2Set(id,rounds) {
    this.id = id;
    this.rounds = rounds;
}
function Axes2Round(id, originalRoundId, type, title, matches) {
	this.id = id;
    this.originalRoundId = originalRoundId;
    this.type = type;
  	this.title = title;
	this.matches = matches;
}
function Axes2Match(id, originalMatchId, matchPlayers) {
    this.id = id;
    this.originalMatchId = originalMatchId;
    this.title = ("Match " + this.id);
	this.matchPlayers = matchPlayers;
    this.display = false;
    this.completed = false;
    this.winnerId = null;
}
function Axes2MatchPlayer(id, throws, player, bye) {
	this.id = id;
    this.throws = throws;
    this.player = player;
    this.finals = false;
    this.winner = false;
    this.bye = bye;
}
function Axes2Throw(id) {
	this.id = id;
	this.basicScore = 0;
	this.xPos = 0;
	this.yPos = 0;
	this.isBullsEye = false;
    this.isVisible = false;
    this.isActive = false;
    this.scored = false;
    this.axes2Score = (this.basicScore*this.basicScore)
}

</script>

<style lang="scss" scoped>
    .signatureFormUpload {
        margin: 5px;
        padding: 5px;
        border: solid gray 1px;
        background-color: silver;
        font-size: 1.2em;
    }
    .custom_checkbox
    {
        /* Double-sized Checkboxes */
        -ms-transform: scale(2); /* IE */
        -moz-transform: scale(2); /* FF */
        -webkit-transform: scale(2); /* Safari and Chrome */
        -o-transform: scale(2); /* Opera */
        transform: scale(2);
        padding: 10px;
    }
    .emoji-green {
        margin: 5px;
        font-size: 30pt;
        font-weight: bold;
        color: rgb(160, 223, 160);
    }
    .emoji-yellow {
        margin: 5px;
        font-size: 30pt;
        font-weight: bold;
        color: rgb(234, 234, 192);
    }
    .emoji-red {
        margin: 5px;
        font-size: 30pt;
        font-weight: bold;
        color: rgb(218, 158, 158);
    }
    .mood-content-box {
        padding: 5px;
    }
    .mood-info-box {
        border: solid 1px goldenrod;
        border-radius: 10px;
        padding: 10px;
        margin-top: 10px;
        /*margin: 10px;*/        
        /*
        padding-bottom: 20px;
        max-width: 280px; 
        margin: auto;
        */
    }
    .mood-inner-box {
    }
    .mood-heading {
        font-family: '28 Days Later';
        font-size: 14pt;
        font-weight: bold;
        color: goldenrod;
        text-decoration: underline;
        cursor: pointer;
        padding: 5px;
    }
    .mood-heading-icon {
        font-size: 14pt;
        color: goldenrod;
    }

    .rankings {
        border: solid yellow 1px;
        background-Color: black !important;
        color: yellow !important;
    }
    .required_title {
        font-size: 8pt; 
        color: red; 
        font-weight: normal;
        vertical-align: middle;
    }
    .weather_container {
        width: 100%;
        padding: 4px;
        border: solid goldenrod 1px; 
        border-radius: 10px;
        margin-bottom: 10px; 
        color: #03fc45;
        font-family: Courier;
    }
    .weather_container_inner {
        min-width: 320px;
        padding-left: 10px;
    }
    .weather_container_subtitle {
        font-size: 0.8em;
        color: #03fc45;
    }
    .info-card-inner {
        background-Color: #202020;
        padding: 10px;
        max-height: 400px;
        width: 100%;
        overflow-x: auto;
        overflow-y: auto;
    }
    .info-card {
        background-color: black;
        position: absolute;
        top: 50px;
        left: 50px;
        height: 500px;
        border: solid yellow 2px;
        border-radius: 25px;
        font-family: 'Courier New', Courier, monospace;
        font-size: 10pt;
        color: yellow;
        padding: 20px;
        z-Index: 1000;
        width: 350px;
    }
    .subtitle {
        color: green;
    }
    .gamesetup {
        padding: 10px;
        border-radius: 10px;
        border: solid goldenrod 1px;
    }
    .finals-player-name {
    }
    .finals-player {
        display: inline-block;
        width: 180px;
        padding-left: 8px;
    }
    .blink {
        color: yellow;
        animation: blink-animation 1s steps(5, start) infinite;
        -webkit-animation: blink-animation 1s steps(5, start) infinite;
    }
    @keyframes blink-animation {
        to {
        visibility: hidden;
        }
    }
    @-webkit-keyframes blink-animation {
        to {
        visibility: hidden;
        }
    }
    .box {
        box-shadow: none;
    }
    .populateUser {
        padding: 3px;
        cursor: pointer;
    }
    .radio-gameType {
        height: 2em;
        width: 2em;
    }
    p {
        color: white;
    }
    .box.button {
        margin-right: 10px;        
    }
    .score {
        font-family: Verdana;
        color: white;
    }
    .score-label {
        padding-right: 10px;
    }
    .throw-points {
        padding: 3px;
        border-radius: 5px;
        background-color: rgb(154, 157, 161);
    }
    .title, .subtitle {
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .set-title {
        font-family: '28 Days Later';
        color: red !important;
    }
    .hero {
        background-color: black;
        margin-bottom: 20px;
    }
    .letsplay {
        margin: 6px;
    }
    .selected {
        background-color: yellow;
    }
    .box {
        background-color: #383838;
    }
    .score-button {
        margin-right: 10px;
        display: inline;
    }
    .finals-heading {
        color: red !important;
        font-family: '28 Days Later';
    }
    .game-finals {
        color: white;
        background-color: black;
        border: solid yellow 1px;
        border-radius: 5px !important;
        margin-bottom: 10px !important;
    }
    .gameTitle {
        color: red !important;
        font-family: '28 Days Later'
    }
</style>